import { useEffect, useState, useRef } from "react";
import {
  IonCard,
  IonContent,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonButtons,
  IonCardHeader,
  IonCardTitle,
  IonBadge,
  IonIcon,
  IonText,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonModal,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import Header from "src/components/Header";
import { arrowBackOutline, checkmarkCircle, mail, search } from "ionicons/icons";
import "src/pages/PedidoProducto.css";
import { useHistory, useLocation, withRouter } from "react-router";
import { closeCircle } from "ionicons/icons";
import { Divider } from "@material-ui/core";
import {
  fetchAcumuladoMes,
  fetchCancelarPedido,
  //fetchFechaPedidos, ya no se usará
  fetchInventarioProducto,
  fetchObtenerProducto,
  fetchProductoSolicitado,
  fetchRangoPedido,
  fetchRealizaModificacion,
  fetchRealizarPedido,
  fetchRechazarPedido,
  handleFetchComments,
  IDetallePedido,
  IProductoInventarioDatos,
  IProductoList,
  RangoPedido,
} from "src/services/PedidoDeProducto/pedido.producto.services";
import {
  fetchAlternativasProducto,
  fetchStockPedido,
  fetchUltimoPedidoReal,
  IAlternativaProducto,
  IAlternativasResponse,
  IFaltanteStock,
  IStockProducto,
  registrarAlternativaProducto,
} from "src/services/PedidoDeProducto/pedido.producto.services";
import CommentsDialog from "src/components/pedidoProductos/ComentarioPedidoProducto";
import { Comment } from "src/components/pedidoProductos/ComentarioPedidoProducto";
import { es } from "date-fns/locale";
import moment from "moment";



interface IPropsResponse {
  cargo: string;
  pedidoNuevo: boolean;
  cabecera: IDetallePedido;
  datos: IDetallePedido;
  facturado: boolean;
  tolerado: number;
  facturarParams: boolean;
  puntoservicio_codigo: string;
  comodato?: boolean | number;
}

const PedidoDeProductos = () => {
  const FECHA_CORTE_TRAZABILIDAD_ENVIO = moment("2026-03-18", "YYYY-MM-DD").startOf("day");
  const history = useHistory();

  const location = useLocation<IPropsResponse>();
  const resultado = location.state;
  const readonly = (resultado as any)?.readonly || false;

  // Código del producto: sirve para saber si un producto ya está en la lista.
  const getProductCode = (p: any) => String(p?.prod_nombre || p?.item_cod || "").trim();

  // Clave única por LÍNEA del pedido: usa el id del detalle cuando existe.
  // Antes se usaba el código, así que dos líneas del mismo producto (mismo código
  // con la descripción cambiada) compartían el contador y se movían como espejo,
  // duplicando la cantidad y el monto del pedido.
  const getProductKey = (p: any) => {
    const idDetalle = Number(p?.id || 0);

    return idDetalle > 0 ? `ID-${idDetalle}` : getProductCode(p);
  };
  // justo después de: const resultado = location.state;
  const cargoUpper = (resultado?.cargo || "").toUpperCase();
  const esGerenciaOperaciones =
    cargoUpper === "GERENTE DE OPERACIONES" ||
    cargoUpper === "GERENTE DE OPERACIONES - UNIDADES ESPECIALIZADAS";
  const comodatoRaw =
    (resultado as any)?.comodato ??
    (resultado?.datos?.cabecera as any)?.comodato ??
    (resultado?.datos as any)?.comodato;
  const esComodato = comodatoRaw === true || Number(comodatoRaw) === 1;

    const nuevoIngresoRaw =
    resultado?.datos?.cabecera?.nuevo_ingreso ??
    resultado?.datos?.nuevo_ingreso ??
    resultado?.pedidoNuevo ??
    resultado?.cabecera?.nuevo_ingreso;
  const esNuevoIngreso =
    nuevoIngresoRaw === 1 ||
    nuevoIngresoRaw === "1" ||
    String(nuevoIngresoRaw).toLowerCase() === "true";


  useEffect(() => {
    // En modo solo lectura (historial), siempre permitir volver atrás sin confirmación
    // y sin cancelar pedidos.
    if (readonly) {
      return;
    }

    // Bloquear la navegación y registrar un callback que se dispara cuando se intenta navegar
    const unblock = history.block((location, action) => {

      // Muestra un cuadro de confirmación para que el usuario decida si quiere navegar
      const confirmExit = window.confirm('¿Estás seguro de que deseas salir?');

      if (confirmExit) {
        // Si el usuario confirma, desbloqueamos la navegación y procedemos
        unblock(); // Desbloquear para permitir la navegación
        const fetchData = async () => {
          try {
            await fetchCancelarPedido(resultado.datos?.id)
              .then((response) => {
                console.log(response)
              })
          } catch (error) {
            console.log(error)
          }
        };

        fetchData()

        // Navegar a la ubicación solicitada (ej: volver atrás)
        history.push(location.pathname + (location.search || "") + (location.hash || ""));
      } else {
        // Si el usuario cancela, no hacemos nada y la navegación no ocurre
        // console.log('Navegación cancelada por el usuario');
        return false; // Evitar la navegación
      }
    });

    // Limpia el bloqueo al desmontar el componente
    return () => {
      unblock(); // Asegúrate de que se desbloquee cuando se desmonta el componente
    };
  }, [history, resultado.datos?.id, readonly]);

  useEffect(() => {
    if (resultado) {
      const hasCabecera = resultado.datos && resultado.datos.cabecera;

      if (hasCabecera) {
        setFacturado(resultado.facturarParams);
        setTolerado(Number(resultado.datos.cabecera.tolerado) || 0);
        setRestante(Number(resultado.datos.cabecera.tolerado_restante) || 0);
        setPS(resultado.datos.cabecera.ps_objeto);
        setCargo(resultado.cargo);
        setHasHead(true);

        const fetchData = async () => {
          const inventarioData = await fetchProductoSolicitado(
            resultado.datos.cabecera.id,
            readonly
          );
          // En un pedido existente el stock solo se muestra: la cantidad ya pedida no se
          // toca, y si hay que bajarla lo exige el backend al modificar. En el historial
          // (solo lectura) no aplica: el stock de hoy no dice nada de un pedido viejo.
          if (!readonly) {
            await cargarStock(resultado.datos.cabecera.id);
          }
          const productoData = await fetchObtenerProducto();
          // obtener último pedido real (BC/Proactif) por producto para este PS
          const ultimoReal = await fetchUltimoPedidoReal(resultado.datos.cabecera.ps_objeto || ps);
          const ultimoMapa = ultimoReal?.mapa || {};
          setUltimoPedidoRealCab(ultimoReal?.cabecera || null);

          // Normalizar claves para evitar desajustes por espacios/case entre backend y frontend
          const normalizeKey = (v: any) => String(v ?? "").trim().toUpperCase();
          const ultimoMapaNorm: Record<string, number> = Object.fromEntries(
            Object.entries(ultimoMapa).map(([k, v]) => [normalizeKey(k), Number(v)])
          );
          const getUltimo = (...keys: any[]) => {
            for (const k of keys) {
              const nk = normalizeKey(k);
              if (nk && nk in ultimoMapaNorm) return ultimoMapaNorm[nk];
            }
            return 0;
          };

          const updatedInventario = inventarioData.datos.map((item) => {
            const matchedProduct = productoData.datos.find(
              (producto) => producto.prod_nombre === item.item_cod
            );

            if (matchedProduct) {
              return {
                ...item,
                // Usar el precio del pedido, no del catálogo
                precio_unitario: item.precio_unitario || matchedProduct.precio_unitario,
                stock: matchedProduct.cantidad,
                precio_total: matchedProduct.precio_total,
                ultimo_pedido: getUltimo(item.item_cod, matchedProduct.prod_nombre),
              };
            }
            return {
              ...item,
              ultimo_pedido: getUltimo(item.item_cod),
            };
          });

          const productos = updatedInventario.filter(product => product.hasOwnProperty('precio_unitario'))

          // Inicializar selectedCards y calcular el total
          const newSelectedCards: Record<string, number> = {};
          let newTotal = 0;

          productos.forEach((producto) => {
            const key = getProductKey(producto);

            // Verifica si 'prod_nombre' existe antes de asignarlo
            if (key) {
              // Para pedidos nuevos (hasHead = false), iniciar con cantidad 0
              // Para pedidos existentes (hasHead = true), usar la cantidad del backend
              const cantidadInicial = true ? producto.cantidad : 0; // true porque estamos en el bloque hasCabecera
              newSelectedCards[key] = cantidadInicial;
              newTotal += cantidadInicial * producto.precio_unitario;
            } else {
              console.warn("Producto con prod_nombre undefined:", producto);
            }
          });
          // Actualizar los estados
          console.log('🛒 Productos cargados:', productos.length);
          console.log('💵 Total calculado:', newTotal);
          console.log('📦 Selected cards:', newSelectedCards);
          
          setSelectedCards(newSelectedCards);
          setTotal(newTotal);
          setProductos(productos);
          setResults(productoData.datos);
          // El restante se calculará dinámicamente en el useEffect
        };

        fetchData();
      } else {
        setFacturado(resultado.facturarParams);
        setTolerado(Number(resultado.datos.tolerado) || 0);
        setRestante(Number(resultado.datos.tolerado_restante) || 0);
        setPS(resultado.puntoservicio_codigo);
        // El restante se calculará dinámicamente en el useEffect

        const fetchData = async () => {
          const inventarioData = await fetchInventarioProducto(
            resultado.datos.id
          );
          const {
            mapa: stockCiclo,
            hayDatos: hayStockCiclo,
            bloquea: bloqueaStockCiclo,
          } = await cargarStock(resultado.datos.id);
          const productoData = await fetchObtenerProducto();
          // obtener último pedido real (BC/Proactif) por producto para este PS
          const ultimoReal = await fetchUltimoPedidoReal(resultado.puntoservicio_codigo || ps);
          const ultimoMapa = ultimoReal?.mapa || {};
          setUltimoPedidoRealCab(ultimoReal?.cabecera || null);

          // Normalizar claves para evitar desajustes por espacios/case entre backend y frontend
          const normalizeKey = (v: any) => String(v ?? "").trim().toUpperCase();
          const ultimoMapaNorm: Record<string, number> = Object.fromEntries(
            Object.entries(ultimoMapa).map(([k, v]) => [normalizeKey(k), Number(v)])
          );
          const getUltimo = (...keys: any[]) => {
            for (const k of keys) {
              const nk = normalizeKey(k);
              if (nk && nk in ultimoMapaNorm) return ultimoMapaNorm[nk];
            }
            return 0;
          };

          const buscarEnCatalogo = (codigo: any) =>
            productoData.datos.find(
              (producto) => normalizeKey(producto.prod_nombre) === normalizeKey(codigo)
            );

          // Si se bloquea sin stock, la precarga no puede pasar lo que queda disponible en
          // el ciclo (sin fila en la tabla de stock = sin stock)
          const recortarAlDisponible = (codigo: any, cantidad: number) => {
            if (!hayStockCiclo || !bloqueaStockCiclo) return cantidad;
            const item = stockCiclo[normalizeKey(codigo)];
            return Math.min(cantidad, item ? item.disponible : 0);
          };

          // 1) Lo cargado en la ÚLTIMA fiscalización del PS: entra con la cantidad
          // contada como precarga del pedido (recortada al disponible).
          const updatedInventario = inventarioData.datos.map((item) => {
            const matchedProduct = buscarEnCatalogo(item.item_cod);
            const cantidadFiscalizada = Number(item.cantidad_precarga ?? 0) || 0;
            const cantidadPrecarga = recortarAlDisponible(item.item_cod, cantidadFiscalizada);
            const precargaAjustada = cantidadPrecarga < cantidadFiscalizada;

            if (matchedProduct) {
              return {
                ...item,
                prod_nombre: matchedProduct.prod_nombre,
                precio_unitario: matchedProduct.precio_unitario,
                stock: matchedProduct.cantidad,
                cantidad: cantidadPrecarga,
                precarga_ajustada: precargaAjustada,
                origen_lista: "FISCALIZACION",
                ultimo_pedido: getUltimo(item.item_cod, matchedProduct.prod_nombre),
              };
            }
            return {
              ...item,
              cantidad: cantidadPrecarga,
              precarga_ajustada: precargaAjustada,
              origen_lista: "FISCALIZACION",
              ultimo_pedido: getUltimo(item.item_cod),
            };
          });
          const productosFiscalizados = updatedInventario.filter(product => product.hasOwnProperty('precio_unitario'))

          // 2) Líneas del último remito de BC que no vinieron en la fiscalización: se
          // ofrecen en la lista pero SIN cantidad, para que el solicitante decida.
          const codigosFiscalizados = new Set(
            productosFiscalizados.map((producto) => normalizeKey(producto.item_cod))
          );
          const productosUltimoPedido = (ultimoReal?.items || [])
            .filter((linea) => !codigosFiscalizados.has(normalizeKey(linea.item_no)))
            .map((linea) => {
              const matchedProduct = buscarEnCatalogo(linea.item_no);

              // Sin precio vigente en la lista EM el producto no se puede pedir
              if (!matchedProduct) return null;

              return {
                id: 0,
                item_cod: String(linea.item_no || "").trim(),
                item_desc: linea.descripcion || matchedProduct.prod_descripcion || "",
                item_stock: 0,
                stock: matchedProduct.cantidad,
                precio: 0,
                precio_unitario: matchedProduct.precio_unitario,
                prod_nombre: matchedProduct.prod_nombre,
                prod_descripcion: matchedProduct.prod_descripcion || linea.descripcion || "",
                cantidad: 0,
                origen_lista: "ULTIMO_PEDIDO",
                ultimo_pedido: getUltimo(linea.item_no) || Number(linea.cantidad) || 0,
              };
            })
            .filter((producto) => producto !== null);

          const productos = [...productosFiscalizados, ...productosUltimoPedido];

          // Precargar el contador de cada tarjeta y el total con lo fiscalizado
          const newSelectedCards: Record<string, number> = {};
          let newTotal = 0;

          productos.forEach((producto) => {
            const key = getProductKey(producto);
            const cantidadInicial = Number(producto.cantidad || 0);

            if (key && cantidadInicial > 0) {
              newSelectedCards[key] = cantidadInicial;
              newTotal += cantidadInicial * (producto.precio_unitario || 0);
            }
          });

          setSelectedCards(newSelectedCards);
          setTotal(newTotal);
          setProductos(productos);
          setResults(productoData.datos);
        };

        fetchData();
      }
    }
  }, [resultado]);

  const [loading, setLoading] = useState(true);
  const [facturado, setFacturado] = useState(false);
  const [ps, setPS] = useState("");
  const [productos, setProductos] = useState<IProductoInventarioDatos[]>([]);
  const [pedidoRechazado, setPedidoRechazado] = useState(false);
  const [results, setResults] = useState<IProductoList[]>([]);
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState("");
  const [cargo, setCargo] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const [selectedCards, setSelectedCards] = useState<{ [key: string]: number }>(
    {}
  );
  const [total, setTotal] = useState(0);
  const [tolerado, setTolerado] = useState(0);
  const [restante, setRestante] = useState(0);
  const inputRef = useRef<HTMLIonInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [porcentaje, setPorcentaje] = useState(0);
  const [exceso, setExceso] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [present] = useIonToast();
  const [comments, setComments] = useState<Comment[]>([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [signal, setSignal] = useState(false);
  // true cuando la aceptación devolvió estado_envio='procesando' (envío a Proactif
  // corriendo en segundo plano). Ajusta el texto de la pantalla de confirmación.
  const [procesandoEnvio, setProcesandoEnvio] = useState(false);
  // Mensaje del backend tras aceptar (ej. "pasó a Aprobación Gerencia"), para
  // mostrar en la confirmación en vez de asumir siempre "enviado".
  const [infoAceptacion, setInfoAceptacion] = useState<string>("");
  const [hasHead, setHasHead] = useState(false);
  // Vista previa: el pedido se envía recién cuando el usuario confirma en el modal
  const [vistaPreviaAbierta, setVistaPreviaAbierta] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [midTotal, setMidTotal] = useState(0);
  const [dentroHorario, setDentroHorario] = useState<boolean>(true);

  // NUEVO: cabecera del último pedido real (BC/Proactif) para mostrar el número de pedido
  const [ultimoPedidoRealCab, setUltimoPedidoRealCab] = useState<any>(null);

  // Stock disponible del ciclo por código: stock de BC menos lo que ya piden los otros
  // pedidos del mes en aprobación o enviados. Vacío = sin datos de stock, no se restringe.
  const [stockMap, setStockMap] = useState<Record<string, IStockProducto>>({});
  const [stockSincronizado, setStockSincronizado] = useState<string | null>(null);
  // false: no se cargó el stock (historial) o no se pudo leer; en ese caso no se restringe
  const [hayDatosStock, setHayDatosStock] = useState(false);
  // false: el stock y las alternativas se muestran, pero un producto sin stock (o por
  // encima del disponible) igual se puede pedir. Lo decide el backend (PP_BLOQUEAR_SIN_STOCK).
  const [bloqueaSinStock, setBloqueaSinStock] = useState(false);

  const normalizarCodigo = (valor: any) => String(valor ?? "").trim().toUpperCase();

  // Disponible del producto, o null cuando no hay datos de stock. Un código que no
  // figura en la tabla de stock cuenta como sin stock, igual que en el backend.
  const getDisponible = (producto: any): number | null => {
    if (!hayDatosStock) return null;
    const item = stockMap[normalizarCodigo(getProductCode(producto))];
    return item ? item.disponible : 0;
  };

  const cargarStock = async (idPc: number) => {
    const respuesta = await fetchStockPedido(idPc);
    const mapa = respuesta.con_stock ? respuesta.datos : {};
    setStockMap(mapa);
    setHayDatosStock(respuesta.con_stock);
    setStockSincronizado(respuesta.sincronizado);
    setBloqueaSinStock(respuesta.bloquea_sin_stock);
    return { mapa, hayDatos: respuesta.con_stock, bloquea: respuesta.bloquea_sin_stock };
  };

  // Alternativas para un producto sin stock: salen de la clasificación del catálogo
  // (misma familia y atributos que tienen que coincidir), no de la IA en vivo.
  const [productoSinStock, setProductoSinStock] = useState<IProductoInventarioDatos | null>(null);
  const [alternativas, setAlternativas] = useState<IAlternativasResponse | null>(null);
  const [cargandoAlternativas, setCargandoAlternativas] = useState(false);

  // Cuánto quería el fiscal del producto sin stock: lo fiscalizado o, si no, lo del último pedido
  const cantidadDeseada = (producto: any) =>
    Math.max(1, Math.ceil(Number(producto?.cantidad_precarga || producto?.ultimo_pedido || 1)));

  // Cada apertura del modal tiene su número: una respuesta que llega tarde (se abrió otro
  // producto mientras tanto) se descarta, y la elección se registra una sola vez por apertura
  const aperturaAlternativasRef = useRef(0);
  const eleccionHechaRef = useRef(false);

  const abrirAlternativas = async (producto: IProductoInventarioDatos) => {
    const idPc = resultado.datos.id || resultado.datos.cabecera.id;
    const apertura = ++aperturaAlternativasRef.current;
    eleccionHechaRef.current = false;
    setProductoSinStock(producto);
    setAlternativas(null);
    setCargandoAlternativas(true);
    const respuesta = await fetchAlternativasProducto(
      idPc,
      getProductCode(producto),
      cantidadDeseada(producto)
    );
    if (apertura !== aperturaAlternativasRef.current) return;
    setAlternativas(respuesta);
    setCargandoAlternativas(false);
  };

  const cerrarAlternativas = () => {
    aperturaAlternativasRef.current++;
    setProductoSinStock(null);
    setAlternativas(null);
    setCargandoAlternativas(false);
  };

  // Auditoría: aceptada / modificada / rechazada la decide el backend según lo elegido
  const registrarEleccion = (codigoElegido: string | null) => {
    if (!productoSinStock || !alternativas) return;
    const idPc = resultado.datos.id || resultado.datos.cabecera.id;
    registrarAlternativaProducto(idPc, {
      cod_origen: getProductCode(productoSinStock),
      cod_elegido: codigoElegido,
      alternativas: alternativas.alternativas.map((alternativa) => alternativa.codigo),
      cantidad: cantidadDeseada(productoSinStock),
      disponible_origen: getDisponible(productoSinStock) ?? undefined,
    });
  };

  const usarAlternativa = (alternativa: IAlternativaProducto) => {
    if (!productoSinStock || eleccionHechaRef.current) return;

    const codigoNuevo = normalizarCodigo(alternativa.codigo);
    if (productos.some((p) => normalizarCodigo(getProductCode(p)) === codigoNuevo)) {
      present({
        color: "warning",
        message: `${alternativa.codigo} ya está en el pedido: ajustá su cantidad en esa tarjeta`,
        duration: 5000,
      });
      return;
    }

    const keyOriginal = getProductKey(productoSinStock);
    // Si vino del buscador no es una línea del pedido: la alternativa se agrega
    const enLista = productos.some((p) => getProductKey(p) === keyOriginal);
    const cantidadOriginal = enLista ? selectedCards[keyOriginal] || 0 : 0;
    const precioOriginal = productoSinStock.precio_unitario || productoSinStock.precio || 0;
    const cantidad = Math.min(Math.max(1, alternativa.cantidad_sugerida), alternativa.disponible);
    eleccionHechaRef.current = true;

    const nuevo: IProductoInventarioDatos = {
      item_cod: alternativa.codigo,
      item_desc: alternativa.descripcion,
      precio_unitario: alternativa.precio_unitario,
      stock: 0,
      precio: 0,
      item_stock: 0,
      cantidad,
      prod_descripcion: alternativa.descripcion,
      prod_nombre: alternativa.codigo,
      id: 0,
    };
    (nuevo as any).reemplaza_a = getProductCode(productoSinStock);

    // La línea sin stock se reemplaza en el mismo lugar (todavía no está guardada); si el
    // producto vino del buscador, la alternativa entra como una línea nueva
    setProductos((prev) =>
      enLista ? prev.map((p) => (getProductKey(p) === keyOriginal ? nuevo : p)) : [...prev, nuevo]
    );
    setSelectedCards((prev) => {
      const nuevas = { ...prev };
      delete nuevas[keyOriginal];
      nuevas[getProductKey(nuevo)] = cantidad;
      return nuevas;
    });
    setTotal(
      (prev) => prev - cantidadOriginal * precioOriginal + cantidad * (alternativa.precio_unitario || 0)
    );

    registrarEleccion(alternativa.codigo);
    present({
      color: "success",
      message: enLista
        ? `${getProductCode(productoSinStock)} reemplazado por ${alternativa.codigo} (${cantidad} u.)`
        : `Agregado ${alternativa.codigo} (${cantidad} u.) en lugar de ${getProductCode(productoSinStock)}`,
      duration: 4000,
    });
    cerrarAlternativas();
  };

  const rechazarAlternativas = () => {
    if (eleccionHechaRef.current) return;
    eleccionHechaRef.current = true;
    registrarEleccion(null);
    cerrarAlternativas();
  };

  // Mensaje con los productos a los que no les alcanza el stock (409 del backend)
  const avisarFaltantes = (faltantes: IFaltanteStock[]) => {
    const detalle = faltantes
      .map((f) =>
        f.sin_registro
          ? `${f.codigo}: no figura en el stock`
          : `${f.codigo}: pediste ${f.solicitado}, hay ${f.disponible}`
      )
      .join(" · ");
    present({
      color: "warning",
      message: `No hay stock suficiente. ${detalle}. Se ajustaron las cantidades al disponible; revisalas antes de volver a enviar.`,
      duration: 9000,
    });
  };

  // Lleva cada línea con faltante al disponible que informó el backend. Una que queda
  // en 0 sale del pedido nuevo; en uno existente (mínimo 1) hay que eliminarla a mano.
  const ajustarAFaltantes = (faltantes: IFaltanteStock[]) => {
    const disponiblePorCodigo = new Map(
      faltantes.map((f) => [normalizarCodigo(f.codigo), Math.max(0, Math.floor(f.disponible))])
    );
    setSelectedCards((prev) => {
      const nuevas = { ...prev };
      productos.forEach((p) => {
        const disponible = disponiblePorCodigo.get(normalizarCodigo(getProductCode(p)));
        const key = getProductKey(p);
        if (disponible === undefined || !(key in nuevas)) return;
        if (disponible > 0) nuevas[key] = Math.min(nuevas[key], disponible);
        else if (!hasHead) delete nuevas[key];
      });
      setTotal(totalDe(nuevas));
      if (hasHead) setMidTotal(totalDe(nuevas));
      return nuevas;
    });
  };

  const totalDe = (cantidades: { [key: string]: number }) =>
    productos.reduce((suma, p) => {
      const cantidad = cantidades[getProductKey(p)] || 0;
      return suma + cantidad * (p.precio_unitario || p.precio || 0);
    }, 0);

  // NUEVO: historial de eliminaciones cargado desde backend
  const [eliminaciones, setEliminaciones] = useState<any[]>([]); // Lista de eliminaciones

  // --- NUEVO: acumulado y restantes mensuales
  const [acumuladoMes, setAcumuladoMes] = useState(0);
  // Meses que abarca el acumulado: 1 mensual, 2 bimestral, 3 trimestral
  const [frecuenciaMeses, setFrecuenciaMeses] = useState(1);
  const [restantePrevio, setRestantePrevio] = useState(0);
  const [restanteConEste, setRestanteConEste] = useState(0);


  // Helper de formato (PYG)
  const formatPYG = (n: number) =>
    (Number(n) || 0).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  const fechaPedidoReferencia = (resultado?.datos?.cabecera as any)?.fecha ?? (resultado?.datos as any)?.fecha;
  const mostrarTrazabilidadEnvio = moment(fechaPedidoReferencia).isValid() && moment(fechaPedidoReferencia).isSameOrAfter(FECHA_CORTE_TRAZABILIDAD_ENVIO);
  const productosNoEnviados = productos.filter((producto: any) => Number(producto?.enviado || 0) !== 1).length;
  const cabeceraEnviado = Number((resultado?.datos?.cabecera as any)?.enviado ?? (resultado?.datos as any)?.enviado ?? 0) === 1;
  const hayInconsistenciaEnvio = readonly && mostrarTrazabilidadEnvio && cabeceraEnviado && productos.length > 0 && productosNoEnviados > 0;



  // --- NUEVO: traer acumulado mensual del backend para el PS actual ---
  useEffect(() => {
    // Necesitamos el ps y una fecha del mes en curso. 
    // Si tenemos fecha en cabecera (pedido existente), usamos esa. Si no, usamos hoy (local).
    let fechaISO = "";
    const cabecera = resultado?.datos?.cabecera || resultado?.datos;
    
    if (cabecera?.fecha && cabecera.fecha.length >= 10) {
      fechaISO = cabecera.fecha.slice(0, 10);
    } else {
      // Usar fecha local para evitar problemas de timezone con UTC
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      fechaISO = `${year}-${month}-${day}`;
    }

    const idPC = resultado?.datos?.cabecera?.id || resultado?.datos?.id;

    console.log('🔍 DEBUG Acumulado:', { ps, fechaISO, idPC, resultado });

    if (!ps) {
      console.log('⚠️ PS no definido, esperando...');
      return; // aún no tenemos el PS
    }

    const run = async () => {
      try {
        const esAFacturar = Boolean((cabecera as any)?.facturar ?? facturado ?? (resultado as any)?.facturarParams);
        console.log('📡 Llamando fetchAcumuladoMes:', { ps, fechaISO, idPC, esAFacturar });
        const esEpi = (cabecera as any)?.epi;
        const acum = await fetchAcumuladoMes(ps, fechaISO, idPC, esAFacturar, esEpi);
        console.log('✅ Acumulado recibido:', acum);
        setAcumuladoMes(acum.acumulado || 0);
        setFrecuenciaMeses(acum.frecuenciaMeses);
      } catch (error) {
        console.error('❌ Error al obtener acumulado:', error);
        setAcumuladoMes(0);
        setFrecuenciaMeses(1);
      }
    };
    run();
  }, [ps, resultado?.datos?.cabecera?.id, resultado?.datos?.id, facturado]);

  useEffect(() => {
    const tol  = Number(tolerado) || 0;
    const tot  = esComodato ? 0 : (Number(total) || 0);
    const acum = Number(acumuladoMes) || 0;

    console.log('💰 Calculando montos:', { tolerado: tol, total: tot, acumuladoMes: acum });

    // Restante antes de este pedido y si lo confirmás
    const previo  = Math.max(0, tol - acum);
    const conEste = Math.max(0, tol - (acum + tot));
    
    console.log('📊 Resultados:', { 
      restantePrevio: previo, 
      restanteConEste: conEste 
    });

    setRestantePrevio(previo);
    setRestanteConEste(conEste);

    // Exceso y porcentaje respecto al MES (acumulado + este pedido)
    const excesoMoney = Math.max(0, (acum + tot) - tol);
    const porc = tol > 0 && excesoMoney > 0 ? (excesoMoney / tol) * 100 : 0;

    setExceso(excesoMoney);
    setPorcentaje(Number(porc.toFixed(1)));

    // Si querés que la tarjeta "RESTANTE" muestre lo que quedaría al confirmar:
    setRestante(conEste);
  }, [total, tolerado, acumuladoMes, esComodato]);

  // NUEVO: Cargar comentarios automáticamente en modo readonly
  useEffect(() => {
    if (readonly) {
      const key = resultado.datos.id || resultado.datos.cabecera.id;
      const fetchComments = async () => {
        try {
          const fetchedComments = await handleFetchComments(key);
          setComments(fetchedComments || []);
        } catch (e) {
          console.error("Error loading comments in readonly mode", e);
        }
      };
      fetchComments();
    }
  }, [readonly, resultado]);

  const cargoResultadoNormalizado = String(resultado?.cargo || "").toLowerCase();
  const esSolicitanteConVentanaFiscal =
    cargoResultadoNormalizado.includes("fiscal") ||
    cargoResultadoNormalizado.includes("lider agentis") ||
    cargoResultadoNormalizado.includes("jefe de operaciones altura") ||
    (cargoResultadoNormalizado.includes("jefe de operaciones") && cargoResultadoNormalizado.includes("altura")) ||
    cargoResultadoNormalizado.includes("jo altura");


  useEffect(() => {
    const validarHorario = async () => {
      if (esComodato || esNuevoIngreso) {
        setDentroHorario(true);
        return;
      }
      if (!ps) {
        // Sin punto de servicio no se puede resolver la unidad de negocio (TD-11079)
        setDentroHorario(false);
        return;
      }
      try {
        // TD-11079: la ventana depende de la unidad de negocio del PS del pedido
        const rango: RangoPedido = await fetchRangoPedido(ps);
        const esFiscal = esSolicitanteConVentanaFiscal;


        // Fecha+hora de inicio y fin según rol
      const inicio = `${esFiscal
        ? rango.fecha_inicio_fiscal
        : rango.fecha_inicio_jefe}T${esFiscal
        ? rango.hora_inicio_fiscal
        : rango.hora_inicio_jefe}`;

      const fin    = `${esFiscal
        ? rango.fecha_fin_fiscal
        : rango.fecha_fin_jefe}T${esFiscal
        ? rango.hora_fin_fiscal
        : rango.hora_fin_jefe}`;

      const start = new Date(inicio);
      const end   = new Date(fin);
      const now   = new Date();

      setDentroHorario(now >= start && now <= end);
      } catch {
        // si falla la petición, por seguridad lo ponemos en false
        setDentroHorario(false);
      }
    };

    validarHorario();
  }, [esSolicitanteConVentanaFiscal, esComodato, esNuevoIngreso, ps]);

  const handleCantidadChange = (
    codigoProducto: string,
    precio: number,
    cantidad: number
  ) => {
    // Tope de stock (solo si se bloquea sin stock): no se puede subir por encima de lo
    // disponible en el ciclo. Una cantidad que ya lo supera (pedido existente) se puede
    // mantener o bajar.
    const productoEditado = productos.find((p) => getProductKey(p) === codigoProducto);
    const disponible =
      productoEditado && bloqueaSinStock ? getDisponible(productoEditado) : null;
    const tope =
      disponible === null ? null : Math.max(disponible, selectedCards[codigoProducto] || 0);
    let recortada = false;

    if (tope !== null && cantidad > tope) {
      present({
        color: "warning",
        message: `Solo hay ${disponible} disponibles de ${getProductCode(productoEditado)} este mes`,
        duration: 3000,
      });
      cantidad = tope;
      recortada = true;
    }

    setSelectedCards((prevSelectedCards) => {
      const newSelectedCards = { ...prevSelectedCards };
      const cantidadAnterior = newSelectedCards[codigoProducto] || 0;

      // Establecer cantidad mínima según tipo de pedido
      const cantidadMinima = hasHead ? 1 : 0; // para pedidos existentes forzar mínimo 1
      let cantidadFinal = cantidad < cantidadMinima ? cantidadMinima : cantidad; // normalizar mínimo

      if (cantidadFinal > 0) {
        newSelectedCards[codigoProducto] = cantidadFinal;
      } else {
        delete newSelectedCards[codigoProducto];
      }

      // Recalcular el total completo basado en todos los productos
      const totalRecalculado = Object.entries(newSelectedCards).reduce((sum, [key, cant]) => {
        const producto = productos.find(p => getProductKey(p) === key);
        if (producto && cant > 0) {
          // Usar la cantidad actual del producto (que se actualiza en el map de abajo)
          const cantidadActual = key === codigoProducto ? cantidadFinal : cant;
          return sum + (cantidadActual * (producto.precio_unitario || producto.precio || 0));
        }
        return sum;
      }, 0);

      console.log("Recalculando total:", {
        codigoProducto,
        cantidadAnterior,
        cantidadFinal,
        precio,
        totalAnterior: total,
        totalRecalculado
      });

      // Actualiza el total siempre para que se refleje en la UI. La cantidad vigente
      // de cada tarjeta vive en selectedCards, que es lo que se envía al confirmar.
      setTotal(totalRecalculado);
      
      // También actualiza midTotal si es necesario para la lógica de backend
      if (hasHead) {
        setMidTotal(totalRecalculado);
      }

      return newSelectedCards;
    });

    // Lo que tiene que mostrar el campo si se recortó (null: lo escrito quedó tal cual)
    if (!recortada) return null;
    return hasHead ? Math.max(1, cantidad) : cantidad || "";
  };

  // El IonInput conserva lo que escribió el usuario aunque el estado se recorte: se
  // corrige a mano para que el campo muestre la cantidad que realmente se va a pedir
  const alCambiarCantidadEscrita = (e: any, producto: any) => {
    const mostrar = handleCantidadChange(
      getProductKey(producto),
      producto.precio || producto.precio_unitario,
      parseInt(e.target.value) || (hasHead ? 1 : 0)
    );
    if (mostrar !== null) e.target.value = mostrar;
  };


  const getBackgroundColor = (excedente) => {
    // Verde: cuando el pedido no excede el tolerado (≤0%)
    if (excedente <= 0) {
      return "rgba(34, 197, 94, 0.9)"; // Verde - En curso
    }
    // Amarillo: cuando necesita aprobación de jefatura (0.1% - 5%)
    else if (excedente <= 5) {
      return "rgba(251, 191, 36, 0.9)"; // Amarillo - Aprobación Jefatura
    }
    // Rojo: cuando necesita aprobación de gerencia (>5%)
    else {
      return "rgba(239, 68, 68, 0.9)"; // Rojo - Aprobación Gerencia
    }
  };

  const handleInput = (ev: CustomEvent) => {
    const query = (ev.target as HTMLInputElement).value?.toLowerCase() || "";
    setValue(query);
  };


  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const fetchMoreProducts = async (event: CustomEvent) => {
    if (!hasMore) {
      (event.target as HTMLIonInfiniteScrollElement).complete();
      return;
    }
  };

  const handleClickProductLabel = (producto: IProductoList, index: number) => {
    // Se compara por CÓDIGO (no por la clave de línea) para no permitir dos tarjetas
    // del mismo producto en el pedido.
    const key = getProductCode(producto); // El producto nuevo entra con id 0, su clave es el código
    // normalizado, igual que usarAlternativa: no importa si un código vino en otras mayúsculas
    const existingIndex = productos.findIndex(
      (p) => normalizarCodigo(getProductCode(p)) === normalizarCodigo(key)
    ); // Busca en el arreglo actual

    if (existingIndex !== -1) { // Ya existe en el arreglo de productos
      present({ // Si existe, se avisa
        color: "warning",
        message: "El producto ya está en la lista",
        duration: 5000,
      });
      return; // Salimos
    }

    // Sin stock en el ciclo, si se bloquea, no se agrega: si el fiscal está armando el
    // pedido se le ofrecen alternativas, igual que en las tarjetas de la lista. Si no se
    // bloquea, se agrega y se le ofrecen igual (más abajo).
    const disponibleNuevo = getDisponible(producto);
    const sinStockNuevo = disponibleNuevo !== null && disponibleNuevo <= 0;
    if (sinStockNuevo && bloqueaSinStock) {
      if (puedeUsarAlternativas) {
        abrirAlternativas(producto);
        return;
      }
      present({
        color: "warning",
        message: `${key} no tiene stock disponible este mes`,
        duration: 5000,
      });
      return;
    }

    // Rename the keys and create a new product object
    const newProduct: IProductoInventarioDatos = {
      item_cod: producto.item_cod || producto.prod_nombre, // Código del ítem, usa prod_nombre como fallback
      item_desc: producto.prod_descripcion || "", // Descripción del ítem
      precio_unitario: producto.precio_unitario || 0, // Precio unitario, 0 si no viene
      stock: producto.cantidad || 0, // Stock disponible en catálogo
      precio: 0, // Precio total (no usado en alta)
      item_stock: 0, // Stock en inventario del pedido (si aplica)
      cantidad: 1, // Cantidad por defecto al agregar desde buscador
      prod_descripcion: producto.prod_descripcion || "", // Descripción de producto
      prod_nombre: producto.prod_nombre || "", // Nombre de producto
      id: 0, // ID 0 (será resuelto en backend al persistir)
    };

    // Add the new product to the list
    setProductos([...productos, newProduct]); // Insertamos el nuevo producto
    
    // Actualizar selectedCards con el nuevo producto
    setSelectedCards((prev) => ({
      ...prev,
      [key]: 1 // Cantidad inicial de 1
    }));
    
    // Recalcular total sumando el valor del nuevo producto
    const valorNuevoProducto = 1 * (producto.precio_unitario || 0);
    setTotal((prevTotal) => prevTotal + valorNuevoProducto);

    // Sin stock y sin bloqueo: queda en el pedido y se ofrecen alternativas; si elige una,
    // reemplaza a esta línea
    if (sinStockNuevo) {
      if (puedeUsarAlternativas) {
        abrirAlternativas(newProduct);
      } else {
        present({
          color: "warning",
          message: `${key} no tiene stock disponible este mes: se pide igual`,
          duration: 4000,
        });
      }
    }
  };

  // ===== Timeout helper =====
  const REQUEST_TIMEOUT_MS = 30000; 

  async function withTimeout<T>(promise: Promise<T>, ms = REQUEST_TIMEOUT_MS) {
    let tid: any;
    const timeout = new Promise<never>((_, reject) => {
      tid = setTimeout(() => reject(new Error("TIMEOUT")), ms);
    });
    try {
      const result = await Promise.race([promise, timeout]);
      clearTimeout(tid);
      return result as T;
    } catch (e) {
      clearTimeout(tid);
      throw e;
    }
  }

  // Ítems que realmente se envían: selectedCards es la fuente de verdad de la
  // cantidad de cada tarjeta (productos conserva la cantidad precargada).
  const getItemsAEnviar = () =>
    productos
      .map((producto) => ({
        ...producto,
        cantidad: Number(selectedCards[getProductKey(producto)] || 0),
      }))
      .filter((producto) => producto.cantidad > 0);

  const itemsVistaPrevia = getItemsAEnviar();
  const totalVistaPrevia = itemsVistaPrevia.reduce(
    (suma, producto) =>
      suma + producto.cantidad * (producto.precio_unitario || producto.precio || 0),
    0
  );

  // Qué va a pasar al confirmar (mismo criterio con el que se arma el botón)
  const destinoPedido = esComodato
    ? "Solicitud de aprobación (comodato)"
    : porcentaje > 0
      ? `Aprobación de Jefatura (excede el tolerado en ${porcentaje}%)`
      : "Envío directo a Proactif";

  // Antes de enviar se muestra la vista previa para que el usuario confirme
  const abrirVistaPrevia = () => {
    if (getItemsAEnviar().length === 0) {
      present({
        color: "warning",
        message: "Cargá la cantidad de al menos un producto",
        duration: 5000,
      });
      return;
    }

    // Lo que ya se sabe que supera el disponible no se manda si se bloquea sin stock: el
    // backend lo rechazaría. Sin bloqueo solo se avisa.
    const excedidos = productos.filter((p) => {
      const disponible = getDisponible(p);
      return disponible !== null && (selectedCards[getProductKey(p)] || 0) > disponible;
    });
    if (excedidos.length > 0 && !bloqueaSinStock) {
      present({
        color: "warning",
        message: `Sin stock suficiente este mes, se piden igual: ${excedidos
          .map((p) => `${getProductCode(p)} (hay ${Math.max(0, getDisponible(p) ?? 0)})`)
          .join(", ")}`,
        duration: 6000,
      });
    } else if (excedidos.length > 0) {
      present({
        color: "warning",
        message: `Superan lo disponible: ${excedidos
          .map((p) => `${getProductCode(p)} (hay ${getDisponible(p)})`)
          .join(", ")}. Ajustá esas cantidades.`,
        duration: 7000,
      });
      return;
    }

    setVistaPreviaAbierta(true);
  };

  const realizarPedido = async () => {
    // Deshabilitamos el boton para que no haga llamados fantasmas
    setVistaPreviaAbierta(false);
    setEnviando(true);

    setLoading(true);

    const productosFinales = getItemsAEnviar();

    if (productosFinales.length === 0) {
      present({ color: "warning", message: "No se modifico el pedido", duration: 5000 });
      setEnviando(false);
      setLoading(false);
      return;
    }

    // log de debug con el payload que se enviara al backend al realizar pedido
    console.log('[PP][realizarPedido] payload productosFinales', { id_pc: resultado.datos.id || resultado.datos.cabecera.id, productosFinales });

    const requestBody = {
      productos: productosFinales.map((producto) => ({
        cantidad: producto.cantidad,
        id: producto.id,
        precio_unitario: producto.precio_unitario,
        prod_descripcion: producto.item_desc || producto.prod_descripcion,
        prod_nombre: producto.item_cod || producto.prod_nombre,
        eliminar: 0,
      })),
    };

    try {
      const idPC = resultado.datos.id || resultado.datos.cabecera.id;

      // ✅ con timeout
      // log de debug con el body final que se enviara al backend
      console.log('[PP][realizarPedido] requestBody', { idPC, requestBody });
      const response = await withTimeout(fetchRealizarPedido(idPC, requestBody));
      // log de debug con la respuesta cruda del backend
      console.log('[PP][realizarPedido] response', response);

      if (!response) {
        present({ color: "danger", message: "No se recibió respuesta del servidor.", duration: 5000 });
        setEnviando(false); // permitir reintentar
        setLoading(false);
        return;
      }

      const estadoEnvio = response?.estado_envio;
      if (estadoEnvio === 'completo') {
        present({ color: "success", message: `${response.info || 'Pedido enviado correctamente a Proactif.'}`, duration: 6000 });
        setSignal(true);
      } else if (estadoEnvio === 'parcial') {
        const detalle = response?.detalle_envio || {};
        const primerError = detalle?.errores?.[0];
        const resumen = `${response.warning || response.info || 'Envio parcial a Proactif.'} (${detalle.ok_items || 0}/${detalle.total || 0})`;
        const msg = primerError
          ? `${resumen}. Ejemplo de error: ${primerError.prod_nombre || 'item'} (${primerError.status}): ${primerError.detalle || 'sin detalle'}`
          : resumen;
        present({ color: "warning", message: msg, duration: 8000 });
        setSignal(true);
      } else if (estadoEnvio === 'error') {
        const detalle = response?.detalle_envio || {};
        const primerError = detalle?.errores?.[0];
        const baseMsg = `${response.warning || response.error || response.info || 'No se pudo completar el envio a Proactif.'}`;
        const msg = primerError
          ? `${baseMsg}. Error: ${primerError.prod_nombre || 'item'} (${primerError.status}): ${primerError.detalle || 'sin detalle'}`
          : baseMsg;
        present({ color: "danger", message: msg, duration: 8000 });
        setSignal(true);
      } else if (Array.isArray(response?.faltantes) && response.faltantes.length > 0) {
        // Otro pedido se llevó el stock mientras este se armaba: se ajusta y se refresca
        ajustarAFaltantes(response.faltantes);
        avisarFaltantes(response.faltantes);
        await cargarStock(idPC);
        setEnviando(false);
      } else if (response?.error) {
        present({ color: "danger", message: `${response.error}`, duration: 6000 });
        setEnviando(false);
      } else {
        present({ color: "success", message: `${response.info || 'Se han agregado los productos al pedido'}`, duration: 5000 });
        setSignal(true);
      }
    } catch (error: any) {
      const isTimeout = error?.message === "TIMEOUT";
      present({
        color: "danger",
        message: isTimeout ? "La operacion sigue procesandose. Revisa el estado del pedido en unos segundos." : `${error}`,
        duration: 5000,
      });
      setEnviando(false); // permitir reintentar
    }

    setLoading(false);
  };

  const realizarPedidoGestion = async (event: any) => {
    // Deshabilitamos el boton para que no haga llamados fantasmas
    event.target.disabled = true;

    setLoading(true);

    if (!esComodato && !esNuevoIngreso) {
      // 1) Obtengo el rango completo (con timeout)
      let rango;
      try {
        rango = await withTimeout(fetchRangoPedido(ps));
      } catch (e: any) {
        present({
          color: "danger",
          message: e?.message === "TIMEOUT" ? "Tiempo de espera agotado al validar fechas" : "No se pudo cargar rango de fechas",
          duration: 4000,
        });
        setLoading(false);
        event.target.disabled = false;
        return;
      }

      // 1.b) Si la unidad de negocio del PS no tiene rango cargado en EMSYS,
      // el backend devuelve datos={}: cortamos en vez de dejar pasar el pedido.
      if (!rango || !rango.fecha_inicio_fiscal || !rango.fecha_inicio_jefe) {
        present({
          color: "danger",
          message: "No hay un rango de fechas activo en EMSYS para la unidad de negocio de este punto de servicio",
          duration: 5000,
        });
        setLoading(false);
        event.target.disabled = false;
        return;
      }

      // 2) Fechas
      const hoy = new Date();
      const esFiscal = esSolicitanteConVentanaFiscal;
      const start = new Date((esFiscal ? rango.fecha_inicio_fiscal : rango.fecha_inicio_jefe) + "T00:00:00");
      const end   = new Date((esFiscal ? rango.fecha_fin_fiscal    : rango.fecha_fin_jefe)   + "T23:59:59");

      // 3) Rango válido
      if (hoy < start || hoy > end) {
        present({ color: "danger", message: "Fuera de fechas disponibles para tu rol", duration: 4000 });
        setLoading(false);
        event.target.disabled = false;
        return;
      }
    }

    // 4) Preparar productos (igual que lo tenías)
    const productosModificados = productos.map((producto) => {
      const key = getProductKey(producto);
      const cantidadActual = selectedCards[key] || producto.cantidad || 0;
      return { ...producto, cantidad: cantidadActual, eliminar: 0, id: producto.id || 0 };
    });

    try {
      const idPC = resultado.datos.id || resultado.datos.cabecera.id;

      // separar existentes y nuevos
      const productosExistentes = productosModificados.filter(p => p.id > 0);
      const productosNuevos     = productosModificados.filter(p => p.id === 0);

      // Si el backend no guardó los cambios (sin stock, lock ocupado u otro error) no se
      // sigue con la aprobación: aceptar enviaría a Proactif las cantidades anteriores
      const cortarPorStock = async (respuesta: any) => {
        if (Array.isArray(respuesta?.faltantes) && respuesta.faltantes.length > 0) {
          ajustarAFaltantes(respuesta.faltantes);
          avisarFaltantes(respuesta.faltantes);
          await cargarStock(idPC);
        } else if (!respuesta || respuesta.error) {
          present({
            color: "danger",
            message: respuesta?.error || "No se pudieron guardar los cambios. Volvé a intentarlo.",
            duration: 6000,
          });
        } else {
          return false;
        }
        event.target.disabled = false;
        setLoading(false);
        return true;
      };

      // 5) Guardar existentes (aceptado=0) con timeout (si hay: con la lista vacía el
      // backend solo respondía un 400 que se ignoraba)
      if (productosExistentes.length > 0) {
        const requestBodyProductos = { productos: productosExistentes, aceptado: 0 };
        // log de debug con productos existentes a modificar
        console.log('[PP][realizarPedidoGestion] requestBodyProductos_existentes', { idPC, requestBodyProductos });
        const respuestaExistentes = await withTimeout(fetchRealizaModificacion(idPC, requestBodyProductos));
        if (await cortarPorStock(respuestaExistentes)) return;
      }

      // 6) Guardar nuevos (aceptado=0) con timeout (si hay)
      if (productosNuevos.length > 0) {
        const requestBodyNuevos = { productos: productosNuevos, aceptado: 0 };
        // log de debug con productos nuevos a insertar
        console.log('[PP][realizarPedidoGestion] requestBodyProductos_nuevos', { idPC, requestBodyNuevos });
        const respuestaNuevos = await withTimeout(fetchRealizaModificacion(idPC, requestBodyNuevos));
        if (await cortarPorStock(respuestaNuevos)) return;
      }

      // 7) Cambiar estado (aceptado=1) con timeout
      const requestBodyEstado = { productos: [], aceptado: 1 };
      // log de debug con el cambio de estado final (aceptado=1)
      console.log('[PP][realizarPedidoGestion] requestBodyEstado', { idPC, requestBodyEstado });
      const responseEstado = await withTimeout(fetchRealizaModificacion(idPC, requestBodyEstado));
      // log de debug con la respuesta del cambio de estado
      console.log('[PP][realizarPedidoGestion] responseEstado', responseEstado);

      if (responseEstado?.error) {
        present({ color: "danger", message: `${responseEstado.error}`, duration: 6000 });
        event.target.disabled = false; // permitir reintentar
      } else if (responseEstado) {
        // El backend responde 202 con estado_envio='procesando': el pedido ya quedó
        // aceptado ("En curso") y el envío a Proactif corre en segundo plano.
        const enProceso = responseEstado.estado_envio === "procesando";
        setProcesandoEnvio(enProceso);
        setInfoAceptacion(responseEstado.info || "");
        present({
          color: enProceso ? "primary" : "success",
          message: enProceso
            ? "Pedido aceptado. Se está enviando a Proactif; podés seguir trabajando, te avisaremos al terminar."
            : `${responseEstado.info}`,
          duration: 6000,
        });
        setSignal(true);
      } else {
        present({ color: "danger", message: "No se recibió respuesta del servidor al intentar modificar.", duration: 5000 });
        event.target.disabled = false; // permitir reintentar
      }
    } catch (error: any) {
      const isTimeout = error?.message === "TIMEOUT";
      present({
        color: "danger",
        message: isTimeout ? "La operación tardó demasiado. Volvé a intentarlo." : `${error}`,
        duration: 5000,
      });
      event.target.disabled = false; // permitir reintentar
    }

    setLoading(false);
  };

  const rechazoPedido = async (event: any) => {
    event.target.disabled = true;
    setLoading(true);

    if (!esNuevoIngreso) {
      // Obtener el rango de fechas
      let rango;
      try {
        rango = await withTimeout(fetchRangoPedido(ps));
      } catch (e: any) {
        present({
          color: "danger",
          message: e?.message === "TIMEOUT" ? "Tiempo de espera agotado al validar fechas." : "No se pudo cargar el rango de fechas",
          duration: 4000,
        });
        setLoading(false);
        event.target.disabled = false;
        return;
      }

      if (!rango || !rango.fecha_inicio_fiscal || !rango.fecha_inicio_jefe) {
        present({
          color: "danger",
          message: "No hay un rango de fechas activo en EMSYS para la unidad de negocio de este punto de servicio",
          duration: 5000,
        });
        setLoading(false);
        event.target.disabled = false;
        return;
      }

      const hoy = new Date();
      const cargoUsuario = resultado.cargo.toLowerCase();
      const validarComoJefe =
        cargoUsuario.includes("gerente de operaciones - unidades especializadas") ||
        cargoUsuario.includes("gerente de operaciones") ||
        cargoUsuario.includes("jefe de operaciones");

      const start = new Date((validarComoJefe ? rango.fecha_inicio_jefe : rango.fecha_inicio_fiscal) + "T00:00:00");
      const end   = new Date((validarComoJefe ? rango.fecha_fin_jefe    : rango.fecha_fin_fiscal)   + "T23:59:59");

      if (hoy < start || hoy > end) {
        present({
          color: "danger",
          message: "No est??s en el rango de fechas habilitado para aprobar/rechazar pedidos.",
          duration: 4000,
        });
        setLoading(false);
        event.target.disabled = false;
        return;
      }
    }

    try {
      const idPC = resultado.datos.id || resultado.datos.cabecera.id;

      // ⏱️ con timeout
      const response = await withTimeout(fetchRechazarPedido(idPC));

      if (response) {
        present({ color: "success", message: `${response.info}`, duration: 5000 });
        setPedidoRechazado(true);
      } else {
        present({ color: "danger", message: "No se recibió respuesta del servidor.", duration: 5000 });
        event.target.disabled = false; // reintento
      }
    } catch (error: any) {
      const isTimeout = error?.message === "TIMEOUT";
      present({
        color: "danger",
        message: isTimeout ? "La operación tardó demasiado. Volvé a intentarlo." : `${error}`,
        duration: 5000,
      });
      event.target.disabled = false; // reintento
    }

    setLoading(false);
  };


  const keyEstado = resultado.datos.estado || resultado.datos.cabecera.estado;
  // TD-11079: en la BD el estado sigue llamandose "Aprobación Gerencia Gentis"
  // (para no romper los PA ni el historial), pero al usuario se le muestra el
  // nombre nuevo del area que aprueba.
  const estadoMostrar =
    keyEstado === "Aprobación Gerencia Gentis"
      ? "Aprobación Gerencia Unidades Especializadas"
      : keyEstado;
  const cargoResultado = cargoResultadoNormalizado;
  const esSolicitantePedido =
    cargoResultado.includes("fiscal") ||
    cargoResultado.includes("lider agentis") ||
    cargoResultado.includes("jefe de operaciones altura") ||
    (cargoResultado.includes("jefe de operaciones") && cargoResultado.includes("altura")) ||
    cargoResultado.includes("jo altura");
  const esAprobacionGerencia =
    String(keyEstado || "")
      .toLowerCase()
      .includes("aprobaci") &&
    String(keyEstado || "")
      .toLowerCase()
      .includes("gerencia");

  // Estado normalizado: el nombre llega de la BD y puede venir con acento o espacios
  const estadoNormalizado = String(keyEstado || "").trim().toLowerCase();
  const esEstadoAprobacion = estadoNormalizado.startsWith("aprobaci");
  const esEstadoArmadoPedido =
    estadoNormalizado === "iniciado" || estadoNormalizado === "en curso";

  // Quién puede sacar productos de la lista: el solicitante mientras arma el pedido
  // (la lista viene precargada de la fiscalización y del último pedido) y quien aprueba
  // mientras el pedido está en su bandeja.
  const puedeEliminarItems =
    !readonly &&
    ((esSolicitantePedido && esEstadoArmadoPedido) || esEstadoAprobacion);

  // Reemplazar un producto sin stock por una alternativa: solo el solicitante mientras
  // arma el pedido, porque las líneas todavía no están guardadas
  const puedeUsarAlternativas =
    !readonly && esSolicitantePedido && estadoNormalizado === "iniciado";

  // El solicitante solo puede quitar líneas que todavía no se guardaron (se sacan de la
  // pantalla): borrar una línea ya persistida pasa por gestion/<id>/modificar, que el
  // backend habilita únicamente a jefatura/gerencia.
  const puedeEliminarProducto = (producto: IProductoInventarioDatos) =>
    puedeEliminarItems && (esEstadoAprobacion || !Number(producto?.id || 0));

  // Función para eliminar productos completamente del array
  const handleToggleRemove = async (producto: IProductoInventarioDatos) => { // Recibe el producto de la tarjeta
    const key = getProductKey(producto); // Clave única de la línea

    // Confirmación obligatoria antes de eliminar (se muestra el código, no la clave interna)
    const ok = window.confirm(`¿Eliminar "${getProductCode(producto)}" del pedido?`); // Diálogo de confirmación
    if (!ok) return; // Si cancela, no hacemos nada

    // Si el producto aún no tiene id (no persistido en el pedido), lo quitamos completamente de UI
    if (!producto.id) { // Sin id de detalle
      const key = getProductKey(producto); // Clave única
      
      // Recalcular total restando el valor del producto eliminado
      // Usar la cantidad actual del selectedCards, no del producto original
      const cantidadActual = selectedCards[key] || producto.cantidad || 0;
      const valorEliminado = cantidadActual * (producto.precio_unitario || producto.precio || 0);
      
      console.log("Eliminando producto sin ID:", {
        key,
        cantidadProducto: producto.cantidad,
        cantidadSelectedCards: selectedCards[key],
        cantidadActual,
        precio: producto.precio_unitario || producto.precio,
        valorEliminado,
        totalAnterior: total
      });
      
      setTotal((prevTotal) => prevTotal - valorEliminado);
      
      // Quitar completamente del array de productos
      setProductos((prev) => prev.filter((p) => getProductKey(p) !== key));
      
      // También actualizar selectedCards para que no se cuente en futuros cálculos
      setSelectedCards((prev) => {
        const newSelectedCards = { ...prev };
        delete newSelectedCards[key];
        return newSelectedCards;
      });
      
      present({ color: 'success', message: 'Producto eliminado de la lista (pendiente de guardar).', duration: 4000 }); // Notifica
      return; // Fin anticipado
    }


    try { // Persistencia inmediata vía PATCH gestion/{id_pc}/modificar
      const idPC = resultado.datos.id || resultado.datos.cabecera.id; // Resuelve id del pedido

      // Construye request con SOLO el producto marcado para eliminar
      const requestBody = { // Cuerpo para backend
        productos: [{ // Lista con único ítem
          id: producto.id, // ID del detalle en pedido
          cantidad: producto.cantidad || 0, // Cantidad actual (referencial)
          precio_unitario: producto.precio_unitario || producto.precio || 0, // Precio unitario
          prod_descripcion: producto.item_desc || producto.prod_descripcion || '', // Descripción
          prod_nombre: producto.item_cod || producto.prod_nombre || '', // Código/nombre
          eliminar: 1, // Bandera de eliminación
        }],
        aceptado: 0, // No aceptar aún, solo modificar
      };

      const resp = await fetchRealizaModificacion(idPC, requestBody); // Llama endpoint de gestión
      if (resp && resp.info) { // Si éxito (backend devuelve info)
        // Actualiza UI: quita completamente del listado
        const key = getProductKey(producto); // Clave única
        
        // Recalcular total restando el valor del producto eliminado
        // Usar la cantidad actual del selectedCards, no del producto original
        const cantidadActual = selectedCards[key] || producto.cantidad || 0;
        const valorEliminado = cantidadActual * (producto.precio_unitario || producto.precio || 0);
        
        console.log("Eliminando producto:", {
          key,
          cantidadProducto: producto.cantidad,
          cantidadSelectedCards: selectedCards[key],
          cantidadActual,
          precio: producto.precio_unitario || producto.precio,
          valorEliminado,
          totalAnterior: total
        });
        
        setTotal((prevTotal) => prevTotal - valorEliminado);
        
        // Quitar completamente del array de productos
        setProductos((prev) => prev.filter((p) => getProductKey(p) !== key));
        
        // También actualizar selectedCards para que no se cuente en futuros cálculos
        setSelectedCards((prev) => {
          const newSelectedCards = { ...prev };
          delete newSelectedCards[key];
          return newSelectedCards;
        });
        
        present({ color: 'success', message: resp.info || 'Producto eliminado correctamente', duration: 4000 }); // Toast de éxito
        return; // Fin de handler
      }

      // Si no hubo respuesta válida
      const msg = resp?.error || 'No se pudo eliminar el producto. Intente de nuevo.'; // Mensaje de error preferente
      present({ color: 'danger', message: msg, duration: 5000 }); // Notifica error
    } catch (e: any) { // Manejo de excepción
      const apiErr = e?.response?.data?.error || 'Error al eliminar el producto'; // Extrae mensaje backend si existe
      present({ color: 'danger', message: apiErr, duration: 5000 }); // Notifica error real
    }
  };


  const renderFacturado = (facturado: boolean) => {
    switch (facturado) {
      case true:
        return (
          <>
            <div className="PPCardDetalle">
              <IonCard>
                <IonCardHeader>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      padding: "10px 0"
                    }}
                  >
                    {/* Header con título y porcentaje */}
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%"
                    }}>
                      <h4 style={{ margin: 0, flex: 1 }}>
                        {ps}
                        {esComodato && (
                          <span
                            style={{
                              marginLeft: 8,
                              padding: "2px 6px",
                              borderRadius: 8,
                              background: "#f59e0b",
                              color: "#111827",
                              fontWeight: 700,
                              fontSize: 12,
                            }}
                          >
                            Comodato
                          </span>
                        )}
                      </h4>
                      <IonCard
                        style={{
                          backgroundColor: getBackgroundColor(porcentaje),
                          width: "52px",
                          height: "45px",
                          padding: 5,
                          textAlign: "center",
                          borderRadius: 5,
                          color: "white",
                          margin: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <IonText
                          style={{ fontWeight: "bold", fontSize: "15px" }}
                        >
                          {porcentaje > 0 ? `+${porcentaje.toFixed(1)}%` : `${porcentaje.toFixed(1)}%`}
                        </IonText>
                      </IonCard>
                    </div>

                    {/* Informaci?n financiera en grid */}
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "15px",
                      width: "100%"
                    }}>
                      {esComodato ? (
                        <>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              Consumo actual: {formatPYG(total)}
                            </IonText>
                          </div>
                          {!esAprobacionGerencia && (
                            <div style={{ marginTop: 6, gridColumn: "1 / -1" }}>
                              <IonText style={{ fontWeight: "bold", fontSize: 14, color: "#f97316" }}>
                                Pedido por comodato: va a aprobacion de gerencia.
                              </IonText>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              Tolerado: {formatPYG(tolerado)}
                            </IonText>
                          </div>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              Consumo actual: {formatPYG(total)}
                            </IonText>
                          </div>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              {frecuenciaMeses > 1 ? `Consumo de los últimos ${frecuenciaMeses} meses` : 'Consumo del Mes'}: {formatPYG(consumoTotalMes)}
                            </IonText>
                          </div>

                          <div style={{ marginTop: 6, gridColumn: "1 / -1" }}>
                            <IonText style={{ 
                              fontWeight: "bold", 
                              fontSize: 16,
                              color: consumoTotalMes > toleradoNumber ? "#ef4444" : "#22c55e"
                            }}>
                              {consumoTotalMes > toleradoNumber
                                ? `Exceso / Excedente: ${formatPYG(excedenteMes)}`
                                : `Saldo disponible: ${formatPYG(saldoDisponibleMes)}`
                              }
                            </IonText>
                          </div>
                        </>
                      )}
                    </div>
<div
                      style={{
                        flexBasis: "100%",
                        textAlign: "center",
                        marginTop: "10px",
                      }}
                    >
                      <Divider />
                    </div>
                    <div
                      style={{
                        flexBasis: "100%",
                        textAlign: "center",
                        marginTop: "10px",
                      }}
                    >
                      {!readonly && (
                      resultado &&
                        resultado.cargo &&
                        esSolicitantePedido ? (
                        // Verificar si el estado es "Iniciado" o "En curso"
                        keyEstado === "Iniciado" || keyEstado === "En curso" ? (
                        esComodato ? (
                          <IonButton
                            style={{
                              fontSize: "15px",
                              alignContent: "center",
                            }}
                            onClick={abrirVistaPrevia}
                            disabled={enviando}
                          >
                            Solicitar aprobacion (Comodato)
                          </IonButton>
                        ) : porcentaje <= 0 ? (
                            // Si no excede tolerado ? En curso (Estado 2)
                            <IonButton
                              style={{
                                fontSize: "15px",
                                alignContent: "center",
                              }}
                              onClick={abrirVistaPrevia}
                              disabled={enviando}
                            >
                              Realizar pedido
                            </IonButton>
                          ) : porcentaje > 0 ? (
                            // Si excede tolerado ? Aprobación Jefatura (Estado 3)
                            <IonButton
                              style={{
                                fontSize: "15px",
                                alignContent: "center",
                              }}
                              onClick={abrirVistaPrevia}
                              disabled={enviando}
                            >
                              Solicitar aprobación
                            </IonButton>
                          ) : null
                        ) : null
                      ) : keyEstado === "Aprobación Jefatura" ? (
                        // Estado 3: Jefe puede aceptar/rechazar
                        porcentaje <= 5 ? (
                          // Si excede ≤5% → Jefe puede aceptar (Estado 2)
                          <>
                            <IonButton
                              style={{ fontSize: "15px", alignContent: "center" }}
                              onClick={realizarPedidoGestion}
                            >
                              Aceptar
                            </IonButton>
                            <IonButton
                              style={{ fontSize: "15px", alignContent: "center" }}
                              onClick={rechazoPedido}
                            >
                              Rechazar
                            </IonButton>
                          </>
                        ) : (
                          // Si excede >5% → Solicitar aprobación Gerencia (Estado 4)
                          <>  
                            <IonButton
                              style={{ fontSize: "15px", alignContent: "center" }}
                              onClick={realizarPedidoGestion}
                            >
                              Solicitar aprobación
                            </IonButton>
                            <IonButton
                                style={{ fontSize: "15px", alignContent: "center" }}
                                onClick={rechazoPedido}
                              >
                                Rechazar
                            </IonButton>
                          </>
                        )
                      ) : (
                        (keyEstado === "Aprobación Gerencia" || keyEstado === "Aprobación Gerencia Gentis") ? (
                          (dentroHorario || esNuevoIngreso) ? (
                            <>
                              <IonButton style={{ fontSize: "15px", alignContent: "center" }} onClick={realizarPedidoGestion}>
                                Aceptar
                              </IonButton>
                              <IonButton style={{ fontSize: "15px", alignContent: "center" }} onClick={rechazoPedido}>
                                Rechazar
                              </IonButton>
                            </>
                          ) : null
                        ) : null
                      )
                      )}
                    </div>
                  </div>
                </IonCardHeader>
              </IonCard>
            </div>
            <div className="ppContainer" ref={containerRef}>
              <div className="PP">
                {!readonly && (
                <IonItem
                  style={{
                    borderRadius: 5,
                    boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.25)",
                  }}
                  className="mt-2"
                >
                  <IonInput
                    ref={inputRef}
                    value={value}
                    onIonChange={(e: any) => handleInput(e)}
                    onFocus={() => setIsFocused(true)}
                    clearInput={true}
                    placeholder="Buscar producto"
                  ></IonInput>
                  <IonIcon icon={search} />
                </IonItem>
                )}
                {isFocused && value.length >= 3 && (
                  <IonInfiniteScroll
                    threshold="100px"
                    onIonInfinite={fetchMoreProducts}
                  >
                    <IonList>
                      {results
                        .filter((producto) => {
                          if (value.startsWith('.')) {
                            return producto.prod_nombre
                              .toLowerCase()
                              .includes(value.replace('.', '').toLowerCase())

                          } else {
                            return producto.prod_descripcion
                              .toLowerCase()
                              .includes(value.toLowerCase())
                          }

                        })
                        .slice(0, 10 + currentPage * itemsPerPage)
                        .map((productos, index) => (
                          <IonItem key={index} button={true}>
                            <IonLabel
                              onClick={() =>
                                handleClickProductLabel(productos, index)
                              }
                            >
                              {productos.prod_descripcion}
                              {getDisponible(productos) !== null && (
                                <p>
                                  {getDisponible(productos) === 0
                                    ? puedeUsarAlternativas
                                      ? "Sin stock disponible · tocá para ver alternativas"
                                      : "Sin stock disponible"
                                    : `Disponible: ${getDisponible(productos)}`}
                                </p>
                              )}
                            </IonLabel>
                          </IonItem>
                        ))}
                    </IonList>
                  </IonInfiniteScroll>
                )}
                <Divider className="mt-2" />

                {hayInconsistenciaEnvio && (
                  <div style={{ marginTop: "10px", marginBottom: "10px", textAlign: "center" }}>
                    <IonBadge color="warning" style={{ fontSize: "13px", whiteSpace: "normal", padding: "8px 10px" }}>
                      Inconsistencia detectada: la cabecera figura enviada, pero hay {productosNoEnviados} item(s) con enviado = 0.
                    </IonBadge>
                  </div>
                )}

                {/* NUEVO: Bloque de historial de eliminaciones si existen registros */}
                {eliminaciones && eliminaciones.length > 0 && (
                  <div className="mt-2" style={{ padding: '8px 0' }}>
                    <IonCard>
                      <IonCardHeader>
                        <IonCardTitle>
                          <h4>Historial de eliminaciones</h4>
                        </IonCardTitle>
                      </IonCardHeader>
                      <div style={{ padding: '8px 16px' }}>
                        {eliminaciones.map((e, i) => (
                          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                            <IonText>{e.prod_nombre} (x{e.cantidad})</IonText>
                            <IonText>{e.fecha_eliminacion}</IonText>
                          </div>
                        ))}
                      </div>
                    </IonCard>
                  </div>
                )}

                {productos.length > 0 &&
                  productos
                    .slice(
                      currentPage * itemsPerPage,
                      (currentPage + 1) * itemsPerPage
                    )
                    .map((producto, index) => (
                      <IonCard key={index} className="PPCardProductoDetalle">
                        <IonCardHeader
                          style={{
                            color: "white", // Color del texto blanco para el header rojo
                            boxShadow: "0px 2px 7px rgba(0, 0, 0, 0.25)",
                            backgroundColor: "var(--ion-color-primary)", // Fondo rojo para todo el header
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 0,
                          }}
                        >
                          <IonLabel style={{ flex: 1, padding: 15, color: "white" }}>
                            {producto.item_cod || producto.prod_nombre}
                          </IonLabel>
                          {/* Campo de cantidad centrado con flechas */}
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1, gap: "8px" }}>
                            {/* Botón flecha hacia arriba */}
                            <IonButton
                              disabled={readonly}
                              size="small"
                              fill="clear"
                              color="light"
                              style={{
                                minWidth: "24px",
                                height: "24px",
                                padding: "0",
                                margin: "0",
                                fontSize: "12px",
                                color: "white"
                              }}
                              onClick={() => {
                                const currentValue = selectedCards[getProductKey(producto)] || (hasHead ? 1 : 0);
                                handleCantidadChange(
                                  getProductKey(producto),
                                  producto.precio || producto.precio_unitario,
                                  currentValue + 1
                                );
                              }}
                            >
                              ▲
                            </IonButton>
                            
                            <IonInput
                              disabled={readonly}
                              type="number"
                              min="1"
                              value={
                                selectedCards[getProductKey(producto)] ||
                                (hasHead ? (producto.cantidad || "1") : "")
                              }
                              onIonChange={(e: any) => alCambiarCantidadEscrita(e, producto)}
                              placeholder="Cantidad"
                              style={{
                                fontWeight: "bold",
                                color: "black", // Texto negro para el campo de cantidad
                                background: "white", // Fondo blanco para el campo de cantidad
                                border: "2px solid white", // Borde blanco para contrastar con el fondo rojo del header
                                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.50)",
                                borderRadius: "3px",
                                textAlign: "center",
                                padding: "8px",
                                width: "60px", // Reducido para dar espacio a las flechas
                              }}
                            />
                            
                            {/* Botón flecha hacia abajo */}
                            <IonButton
                              disabled={readonly}
                              size="small"
                              fill="clear"
                              color="light"
                              style={{
                                minWidth: "24px",
                                height: "24px",
                                padding: "0",
                                margin: "0",
                                fontSize: "12px",
                                color: "white"
                              }}
                              onClick={() => {
                                const currentValue = selectedCards[getProductKey(producto)] || (hasHead ? 1 : 0);
                                const newValue = Math.max(hasHead ? 1 : 0, currentValue - 1); // Para pedidos existentes mínimo 1, para nuevos mínimo 0
                                handleCantidadChange(
                                  getProductKey(producto),
                                  producto.precio || producto.precio_unitario,
                                  newValue
                                );
                              }}
                            >
                              ▼
                            </IonButton>
                          </div>
                          {/* Botón de eliminar alineado a la derecha */}
                          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", flex: 1, paddingRight: "15px" }}>
                            {puedeEliminarProducto(producto) && (
                              <IonButton
                                size="small"
                                color="danger"
                                onClick={() => handleToggleRemove(producto)}
                              >
                                Eliminar
                              </IonButton>
                            )}
                          </div>
                        </IonCardHeader>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                          }}
                          className="PPCardDetalle"
                        >
                          
                          <div
                            style={{ flexBasis: "50%", textAlign: "center" }}
                          >
                            <IonCardTitle>
                              <h4>{producto.prod_descripcion || producto.item_desc}</h4>
                            </IonCardTitle>
                          </div>
                          <div
                            style={{
                              flexBasis: "56%",
                              textAlign: "center",
                              marginBottom: 5,
                              marginTop: 5,
                            }}
                          >
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              Precio:{" "}
                              {producto.precio_unitario ||
                                producto.precio
                                  .toFixed(0)
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </IonText>
                          </div>
                          <div
                            style={{ flexBasis: "50%", textAlign: "center" }}
                          >
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              {producto.stock
                                ? `S"tock: ${producto.stock}`
                                : ""}
                            </IonText>
                          </div>
                          <div
                            style={{ flexBasis: "50%", textAlign: "center" }}
                          >
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              Subtotal:{" "}
                              {(
                                producto.precio_unitario *
                                (selectedCards[getProductKey(producto)] ||
                                  (hasHead ? (producto.cantidad || 0) : 0))
                              )
                                .toFixed(0)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </IonText>
                          </div>
                          <div
                            style={{
                              flexBasis: "100%",
                              textAlign: "center",
                              marginTop: "10px",
                            }}
                          >
                            <Divider />
                          </div>
                          <div
                            style={{
                              flexBasis: "100%",
                              textAlign: "center",
                              marginTop: "10px",
                            }}
                          >
                            {readonly && mostrarTrazabilidadEnvio && (
                              <div style={{ marginBottom: "8px" }}>
                                <IonBadge color={Number((producto as any).enviado || 0) === 1 ? "success" : "danger"}>
                                  {Number((producto as any).enviado || 0) === 1 ? "Enviado a Proactif" : "No enviado a Proactif"}
                                </IonBadge>
                              </div>
                            )}
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "20px" }}
                            >
                              {/* aclarar fuente del inventario */}
                              Inventario: {producto.item_stock}
                            </IonText>
                            <div style={{ marginTop: "4px" }}>
                              <IonText style={{ fontWeight: "bold", fontSize: "18px" }}>
                                Último pedido: {(producto as any).ultimo_pedido ?? 0}
                              </IonText>
                            </div>
                            {/* Stock del ciclo: stock de BC menos lo que ya se pidió este mes */}
                            {getDisponible(producto) !== null && (
                              <div style={{ marginTop: "4px" }}>
                                {getDisponible(producto) === 0 ? (
                                  <>
                                    <IonBadge color="danger">Sin stock disponible</IonBadge>
                                    {puedeUsarAlternativas && (
                                      <div style={{ marginTop: "6px" }}>
                                        <IonButton
                                          size="small"
                                          fill="outline"
                                          onClick={() => abrirAlternativas(producto)}
                                        >
                                          Ver alternativas
                                        </IonButton>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <IonText style={{ fontWeight: "bold", fontSize: "18px" }}>
                                    Disponible: {getDisponible(producto)}
                                  </IonText>
                                )}
                                {(selectedCards[getProductKey(producto)] || 0) > (getDisponible(producto) ?? 0) && (
                                  <div style={{ marginTop: "4px" }}>
                                    <IonBadge color="warning">Supera lo disponible</IonBadge>
                                  </div>
                                )}
                                {(producto as any).precarga_ajustada && (
                                  <div style={{ marginTop: "4px" }}>
                                    <IonBadge color="medium">
                                      Fiscalizado {(producto as any).cantidad_precarga}, ajustado al disponible
                                    </IonBadge>
                                  </div>
                                )}
                                {(producto as any).reemplaza_a && (
                                  <div style={{ marginTop: "4px" }}>
                                    <IonBadge color="tertiary">
                                      Reemplaza a {(producto as any).reemplaza_a}
                                    </IonBadge>
                                  </div>
                                )}
                              </div>
                            )}
                            {/* De dónde salió la línea en un pedido nuevo */}
                            {(producto as any).origen_lista === "FISCALIZACION" && (
                              <div style={{ marginTop: "4px" }}>
                                <IonBadge color="tertiary">
                                  {(producto as any).fis_fecha
                                    ? `Fiscalización ${moment((producto as any).fis_fecha).format("DD/MM/YY")}`
                                    : "Fiscalización"}
                                </IonBadge>
                              </div>
                            )}
                            {(producto as any).origen_lista === "ULTIMO_PEDIDO" && (
                              <div style={{ marginTop: "4px" }}>
                                <IonBadge color="medium">Del último pedido</IonBadge>
                              </div>
                            )}
                          </div>
                          
                        </div>
                      </IonCard>
                    ))}
                <IonButtons className="pagination-buttons">
                  <IonButton
                    onClick={handlePrevPage}
                    disabled={currentPage === 0}
                  >
                    Anterior
                  </IonButton>
                  <IonButton
                    onClick={handleNextPage}
                    disabled={
                      (currentPage + 1) * itemsPerPage >= productos.length
                    }
                  >
                    Siguiente
                  </IonButton>
                </IonButtons>
              </div>
              <CommentsDialog
                open={openDialog}
                onClose={handleClose}
                comments={comments}
                getInitials={getInitials}
                onAddComment={handleAddComment}
                idPC={resultado.datos.id || resultado.datos.cabecera.id}
              />
            </div>
          </>
        );
      case false:
        return (
          <>
            <div className="PPCardDetalle">
              <IonCard>
                <IonCardHeader>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      padding: "10px 0"
                    }}
                  >
                    {/* Header con título y porcentaje */}
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%"
                    }}>
                      <h4 style={{ margin: 0, flex: 1 }}>
                        {ps}
                        {esComodato && (
                          <span
                            style={{
                              marginLeft: 8,
                              padding: "2px 6px",
                              borderRadius: 8,
                              background: "#f59e0b",
                              color: "#111827",
                              fontWeight: 700,
                              fontSize: 12,
                            }}
                          >
                            Comodato
                          </span>
                        )}
                      </h4>
                      <IonCard
                        style={{
                          backgroundColor: getBackgroundColor(porcentaje),
                          width: "52px",
                          height: "45px",
                          padding: 5,
                          textAlign: "center",
                          borderRadius: 5,
                          color: "white",
                          margin: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <IonText
                          style={{ fontWeight: "bold", fontSize: "15px" }}
                        >
                          {(porcentaje >= 0 ? '+' : '') + porcentaje.toFixed(1) + "%"}
                        </IonText>
                      </IonCard>
                    </div>

                    {/* Información financiera en grid */}
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "15px",
                      width: "100%"
                    }}>
                      {esComodato ? (
                        <>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              Consumo actual: {formatPYG(total)}
                            </IonText>
                          </div>
                          {!esAprobacionGerencia && (
                            <div style={{ marginTop: 6, gridColumn: "1 / -1" }}>
                              <IonText style={{ fontWeight: "bold", fontSize: 14, color: "#f97316" }}>
                                Pedido por comodato: va a aprobacion de gerencia.
                              </IonText>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              Tolerado: {formatPYG(tolerado)}
                            </IonText>
                          </div>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              Consumo actual: {formatPYG(total)}
                            </IonText>
                          </div>
                          <div style={{ marginTop: 6 }}>
                            <IonText style={{ fontWeight: "bold", fontSize: 15 }}>
                              {frecuenciaMeses > 1 ? `Consumo de los últimos ${frecuenciaMeses} meses` : 'Consumo del Mes'}: {formatPYG(consumoTotalMes)}
                            </IonText>
                          </div>

                          <div style={{ marginTop: 6, gridColumn: "1 / -1" }}>
                            <IonText style={{ 
                              fontWeight: "bold", 
                              fontSize: 16,
                              color: consumoTotalMes > toleradoNumber ? "#ef4444" : "#22c55e"
                            }}>
                              {consumoTotalMes > toleradoNumber
                                ? `Exceso / Excedente: ${formatPYG(excedenteMes)}`
                                : `Saldo disponible: ${formatPYG(saldoDisponibleMes)}`
                              }
                            </IonText>
                          </div>
                        </>
                      )}
                    </div>
<div
                      style={{
                        flexBasis: "100%",
                        textAlign: "center",
                        marginTop: "10px",
                      }}
                    >
                      <Divider />
                    </div>
                    <div
                      style={{
                        flexBasis: "100%",
                        textAlign: "center",
                        marginTop: "10px",
                      }}
                    >
                      {!readonly && (
                      resultado &&
                        resultado.cargo &&
                        esSolicitantePedido ? (
                        // Verificar si el estado es "Iniciado" o "En curso"
                        keyEstado === "Iniciado" || keyEstado === "En curso" ? (
                        esComodato ? (
                          <IonButton
                            style={{
                              fontSize: "15px",
                              alignContent: "center",
                            }}
                            onClick={abrirVistaPrevia}
                            disabled={enviando}
                          >
                            Solicitar aprobacion (Comodato)
                          </IonButton>
                        ) : porcentaje <= 0 ? (
                            // Si no excede tolerado ? En curso (Estado 2)
                            <IonButton
                              style={{
                                fontSize: "15px",
                                alignContent: "center",
                              }}
                              onClick={abrirVistaPrevia}
                              disabled={enviando}
                            >
                              Realizar pedido
                            </IonButton>
                          ) : porcentaje > 0 ? (
                            // Si excede tolerado ? Aprobación Jefatura (Estado 3)
                            <IonButton
                              style={{
                                fontSize: "15px",
                                alignContent: "center",
                              }}
                              onClick={abrirVistaPrevia}
                              disabled={enviando}
                            >
                              Solicitar aprobación
                            </IonButton>
                          ) : null
                        ) : null
                      ) : keyEstado === "Aprobación Jefatura" ? (
                        // Estado 3: Jefe puede aceptar/rechazar
                        porcentaje <= 5 ? (
                          // Si excede ≤5% → Jefe puede aceptar (Estado 2)
                          <>
                            <IonButton
                              style={{ fontSize: "15px", alignContent: "center" }}
                              onClick={realizarPedidoGestion}
                            >
                              Aceptar
                            </IonButton>
                            <IonButton
                              style={{ fontSize: "15px", alignContent: "center" }}
                              onClick={rechazoPedido}
                            >
                              Rechazar
                            </IonButton>
                          </>
                        ) : (
                          // Si excede >5% → Solicitar aprobación Gerencia (Estado 4)
                          <>
                            <IonButton
                              style={{ fontSize: "15px", alignContent: "center" }}
                              onClick={realizarPedidoGestion}
                            >
                              Solicitar aprobación
                            </IonButton>
                            <IonButton
                                  style={{ fontSize: "15px", alignContent: "center" }}
                                  onClick={rechazoPedido}
                                >
                                Rechazar
                            </IonButton>
                          </>
                          
                        )
                      ) : (
                        (keyEstado === "Aprobación Gerencia" || keyEstado === "Aprobación Gerencia Gentis") ? (
                          (dentroHorario || esNuevoIngreso) ? (
                            <>
                              <IonButton style={{ fontSize: "15px", alignContent: "center" }} onClick={realizarPedidoGestion}>
                                Aceptar
                              </IonButton>
                              <IonButton style={{ fontSize: "15px", alignContent: "center" }} onClick={rechazoPedido}>
                                Rechazar
                              </IonButton>
                            </>
                          ) : null
                        ) : null
                      )
                      )}
                    </div>
                  </div>
                </IonCardHeader>
              </IonCard>
            </div>
            <div className="ppContainer" ref={containerRef}>
              <div className="PP">
                {!readonly && (
                  <IonItem
                    style={{
                      borderRadius: 5,
                      boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.25)",
                    }}
                    className="mt-2"
                  >
                    <IonInput
                      ref={inputRef}
                      value={value}
                      onIonChange={(e: any) => handleInput(e)}
                      onFocus={() => setIsFocused(true)}
                      clearInput={true}
                      placeholder="Buscar producto"
                    ></IonInput>
                    <IonIcon icon={search} />
                  </IonItem>
                )}
                {isFocused && value.length >= 3 && (
                  <IonInfiniteScroll
                    threshold="100px"
                    onIonInfinite={fetchMoreProducts}
                  >
                    <IonList>
                      {results
                        .filter((producto) => {
                          if (value.startsWith('.')) {
                            return producto.prod_nombre
                              .toLowerCase()
                              .includes(value.replace('.', '').toLowerCase())

                          } else {
                            return producto.prod_descripcion
                              .toLowerCase()
                              .includes(value.toLowerCase())
                          }

                        })
                        .slice(0, 10 + currentPage * itemsPerPage)
                        .map((productos, index) => (
                          <IonItem key={index} button={true}>
                            <IonLabel class="ion-text-wrap"
                              onClick={() =>
                                handleClickProductLabel(productos, index)
                              }
                            >
                              <h4>{productos.prod_nombre}</h4>
                              <p>{productos.prod_descripcion}</p>
                              {getDisponible(productos) !== null && (
                                <p>
                                  {getDisponible(productos) === 0
                                    ? puedeUsarAlternativas
                                      ? "Sin stock disponible · tocá para ver alternativas"
                                      : "Sin stock disponible"
                                    : `Disponible: ${getDisponible(productos)}`}
                                </p>
                              )}
                            </IonLabel>
                          </IonItem>
                        ))}
                    </IonList>
                  </IonInfiniteScroll>
                )}
                <Divider className="mt-2" />

                {/* NUEVO: Bloque de historial de eliminaciones si existen registros */}
                {eliminaciones && eliminaciones.length > 0 && (
                  <div className="mt-2" style={{ padding: '8px 0' }}>
                    <IonCard>
                      <IonCardHeader>
                        <IonCardTitle>
                          <h4>Historial de eliminaciones</h4>
                        </IonCardTitle>
                      </IonCardHeader>
                      <div style={{ padding: '8px 16px' }}>
                        {eliminaciones.map((e, i) => (
                          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                            <IonText>{e.prod_nombre} (x{e.cantidad})</IonText>
                            <IonText>{e.fecha_eliminacion}</IonText>
                          </div>
                        ))}
                      </div>
                    </IonCard>
                  </div>
                )}

                {productos.length > 0 &&
                  productos
                    .slice(
                      currentPage * itemsPerPage,
                      (currentPage + 1) * itemsPerPage
                    )
                    .map((producto, index) => (
                      <IonCard key={index} className="PPCardProductoDetalle">
                        <IonCardHeader
                          style={{
                            color: "white", // Color del texto blanco para el header rojo
                            boxShadow: "0px 2px 7px rgba(0, 0, 0, 0.25)",
                            backgroundColor: "var(--ion-color-primary)", // Fondo rojo para todo el header
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 0,
                          }}
                        >
                          <IonLabel style={{ flex: 1, padding: 15, color: "white" }}>
                            {producto.item_cod || producto.prod_nombre}
                          </IonLabel>
                          {/* Campo de cantidad centrado con flechas */}
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1, gap: "8px" }}>
                            {/* Botón flecha hacia arriba */}
                            <IonButton
                              disabled={readonly}
                              size="small"
                              fill="clear"
                              color="light"
                              style={{
                                minWidth: "24px",
                                height: "24px",
                                padding: "0",
                                margin: "0",
                                fontSize: "12px",
                                color: "white"
                              }}
                              onClick={() => {
                                const currentValue = selectedCards[getProductKey(producto)] || (hasHead ? 1 : 0);
                                handleCantidadChange(
                                  getProductKey(producto),
                                  producto.precio || producto.precio_unitario,
                                  currentValue + 1
                                );
                              }}
                            >
                              ▲
                            </IonButton>
                            
                            <IonInput
                              disabled={readonly}
                              type="number"
                              min="1"
                              value={
                                selectedCards[getProductKey(producto)] ||
                                (hasHead ? (producto.cantidad || "1") : "")
                              }
                              onIonChange={(e: any) => alCambiarCantidadEscrita(e, producto)}
                              placeholder="Cantidad"
                              style={{
                                fontWeight: "bold",
                                color: "black", // Texto negro para el campo de cantidad
                                background: "white", // Fondo blanco para el campo de cantidad
                                border: "2px solid white", // Borde blanco para contrastar con el fondo rojo del header
                                boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.50)",
                                borderRadius: "3px",
                                textAlign: "center",
                                padding: "8px",
                                width: "60px", // Reducido para dar espacio a las flechas
                              }}
                            />
                            
                            {/* Botón flecha hacia abajo */}
                            <IonButton
                              disabled={readonly}
                              size="small"
                              fill="clear"
                              color="light"
                              style={{
                                minWidth: "24px",
                                height: "24px",
                                padding: "0",
                                margin: "0",
                                fontSize: "12px",
                                color: "white"
                              }}
                              onClick={() => {
                                const currentValue = selectedCards[getProductKey(producto)] || (hasHead ? 1 : 0);
                                const newValue = Math.max(hasHead ? 1 : 0, currentValue - 1); // Para pedidos existentes mínimo 1, para nuevos mínimo 0
                                handleCantidadChange(
                                  getProductKey(producto),
                                  producto.precio || producto.precio_unitario,
                                  newValue
                                );
                              }}
                            >
                              ▼
                            </IonButton>
                          </div>
                          {/* Botón de eliminar alineado a la derecha */}
                          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", flex: 1, paddingRight: "15px" }}>
                            {/* Botón de eliminar: el solicitante mientras arma el pedido y quien aprueba (Jefatura/Gerencia) */}
                            {puedeEliminarProducto(producto) && (
                              <IonButton
                                size="small" // Botón compacto junto a la cabecera del producto
                                color="danger"
                                onClick={() => handleToggleRemove(producto)}
                              >
                                Eliminar
                              </IonButton>
                            )}
                          </div>
                        </IonCardHeader>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                          }}
                          className="PPCardDetalle"
                        >
                          
                          <div
                            style={{ flexBasis: "50%", textAlign: "center" }}
                          >
                            <IonCardTitle>
                              <h4>{producto.prod_descripcion || producto.item_desc}</h4>
                            </IonCardTitle>
                          </div>
                          <div
                            style={{
                              flexBasis: "56%",
                              textAlign: "center",
                              marginBottom: 5,
                              marginTop: 5,
                            }}
                          >
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              Precio:{" "}
                              {producto.precio_unitario ||
                                producto.precio
                                  .toFixed(0)
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </IonText>
                          </div>
                          <div
                            style={{ flexBasis: "50%", textAlign: "center" }}
                          >
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              {producto.stock
                                ? `S"tock: ${producto.stock}`
                                : ""}
                            </IonText>
                          </div>
                          <div
                            style={{ flexBasis: "50%", textAlign: "center" }}
                          >
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "18px" }}
                            >
                              Subtotal:{" "}
                              {(
                                producto.precio_unitario *
                                (selectedCards[getProductKey(producto)] ||
                                  (hasHead ? (producto.cantidad || 0) : 0))
                              )
                                .toFixed(0)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </IonText>
                          </div>
                          <div
                            style={{
                              flexBasis: "100%",
                              textAlign: "center",
                              marginTop: "10px",
                            }}
                          >
                            <Divider />
                          </div>
                          <div
                            style={{
                              flexBasis: "100%",
                              textAlign: "center",
                              marginTop: "10px",
                            }}
                          >
                            {readonly && mostrarTrazabilidadEnvio && (
                              <div style={{ marginBottom: "8px" }}>
                                <IonBadge color={Number((producto as any).enviado || 0) === 1 ? "success" : "danger"}>
                                  {Number((producto as any).enviado || 0) === 1 ? "Enviado a Proactif" : "No enviado a Proactif"}
                                </IonBadge>
                              </div>
                            )}
                            <IonText
                              style={{ fontWeight: "bold", fontSize: "20px" }}
                            >
                              {/* aclarar fuente del inventario */}
                              Inventario: {producto.item_stock}
                            </IonText>
                            <div style={{ marginTop: "4px" }}>
                              <IonText style={{ fontWeight: "bold", fontSize: "18px" }}>
                                Último pedido: {(producto as any).ultimo_pedido ?? 0}
                              </IonText>
                            </div>
                            {/* Stock del ciclo: stock de BC menos lo que ya se pidió este mes */}
                            {getDisponible(producto) !== null && (
                              <div style={{ marginTop: "4px" }}>
                                {getDisponible(producto) === 0 ? (
                                  <>
                                    <IonBadge color="danger">Sin stock disponible</IonBadge>
                                    {puedeUsarAlternativas && (
                                      <div style={{ marginTop: "6px" }}>
                                        <IonButton
                                          size="small"
                                          fill="outline"
                                          onClick={() => abrirAlternativas(producto)}
                                        >
                                          Ver alternativas
                                        </IonButton>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <IonText style={{ fontWeight: "bold", fontSize: "18px" }}>
                                    Disponible: {getDisponible(producto)}
                                  </IonText>
                                )}
                                {(selectedCards[getProductKey(producto)] || 0) > (getDisponible(producto) ?? 0) && (
                                  <div style={{ marginTop: "4px" }}>
                                    <IonBadge color="warning">Supera lo disponible</IonBadge>
                                  </div>
                                )}
                                {(producto as any).precarga_ajustada && (
                                  <div style={{ marginTop: "4px" }}>
                                    <IonBadge color="medium">
                                      Fiscalizado {(producto as any).cantidad_precarga}, ajustado al disponible
                                    </IonBadge>
                                  </div>
                                )}
                                {(producto as any).reemplaza_a && (
                                  <div style={{ marginTop: "4px" }}>
                                    <IonBadge color="tertiary">
                                      Reemplaza a {(producto as any).reemplaza_a}
                                    </IonBadge>
                                  </div>
                                )}
                              </div>
                            )}
                            {/* De dónde salió la línea en un pedido nuevo */}
                            {(producto as any).origen_lista === "FISCALIZACION" && (
                              <div style={{ marginTop: "4px" }}>
                                <IonBadge color="tertiary">
                                  {(producto as any).fis_fecha
                                    ? `Fiscalización ${moment((producto as any).fis_fecha).format("DD/MM/YY")}`
                                    : "Fiscalización"}
                                </IonBadge>
                              </div>
                            )}
                            {(producto as any).origen_lista === "ULTIMO_PEDIDO" && (
                              <div style={{ marginTop: "4px" }}>
                                <IonBadge color="medium">Del último pedido</IonBadge>
                              </div>
                            )}
                          </div>
                        </div>
                      </IonCard>
                    ))}
                <IonButtons className="pagination-buttons">
                  <IonButton
                    onClick={handlePrevPage}
                    disabled={currentPage === 0}
                  >
                    Anterior
                  </IonButton>
                  <IonButton
                    onClick={handleNextPage}
                    disabled={
                      (currentPage + 1) * itemsPerPage >= productos.length
                    }
                  >
                    Siguiente
                  </IonButton>
                </IonButtons>
              </div>
              <CommentsDialog
                open={openDialog}
                onClose={handleClose}
                comments={comments}
                getInitials={getInitials}
                onAddComment={handleAddComment}
                idPC={resultado.datos.id || resultado.datos.cabecera.id}
              />
            </div>
          </>
        );
      default:
        return <h5>Vuelva a iniciar este pedido</h5>;
    }
  };

  const renderConfirmation = () => (
    <div style={{ textAlign: "center", paddingTop: "20px" }}>
      <div
        style={{
          fontSize: "180px",
          color: "#8C0032",
          marginBottom: "20px",
          marginTop: "60px",
        }}
      >
        <IonIcon icon={checkmarkCircle} />
      </div>
      <h2>{procesandoEnvio ? "Pedido aceptado — enviándose a Proactif" : (infoAceptacion || "Hemos enviado tu pedido de producto.")}</h2>
      {procesandoEnvio && (
        <p style={{ maxWidth: 420, margin: "0 auto 8px" }}>
          El envío se está procesando en segundo plano. Podés seguir trabajando;
          te avisaremos por notificación cuando termine.
        </p>
      )}
      <p>Usa tu ID <strong>{resultado.datos.id || resultado.datos.cabecera.id}</strong>{" "}para consultar su estado</p>
      <p style={{ color: "#8C0032", fontWeight: "bold" }}>
        {resultado.datos.id}
      </p>
      <IonButton color="medium" routerLink="/pedido-de-productos">
        &laquo; volver atrás
      </IonButton>

      <CommentsDialog
        open={openDialog}
        onClose={handleClose}
        comments={comments}
        getInitials={getInitials}
        onAddComment={handleAddComment}
        idPC={resultado.datos.id || resultado.datos.cabecera.id}
      />
    </div>
  );

  useEffect(() => {
    const key = resultado.datos.id || resultado.datos.cabecera.id;

    const fetchComments = async () => {
      const fetchedComments = await handleFetchComments(key);
      setComments(fetchedComments);
    };

    if (openDialog) {
      fetchComments();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDialog]);

  // NUEVO: cargar historial de eliminaciones al montar la vista
    // Historial deshabilitado en UI (solo BD)

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleAddComment = async (comment: Comment) => {
    try {
      // Agregar el comentario localmente
      setComments([...comments, comment]);

      const updatedComments = await handleFetchComments(
        resultado.datos.id || resultado.datos.cabecera.id
      );
      setComments(updatedComments);
    } catch (error) {
      console.error("Error al agregar el comentario:", error);
      // Aquí puedes manejar el error, mostrar una notificación, etc.
    }
  };

  const getInitials = (name: string | undefined) => {
    if (!name) {
      return "N/A"; // O puedes devolver un string vacío o cualquier valor por defecto
    }

    const words = name.split(" ");
    const initials = words
      .filter((word) => word && word.length > 0) // Filtra cualquier palabra que sea undefined o vacía
      .map((word) => word[0].toUpperCase())
      .join("");

    return initials || "N/A"; // Devuelve un valor por defecto si no hay iniciales
  };

  const toleradoNumber = Number(tolerado) || 0;
  const consumoTotalMes = Math.max(
    0,
    (Number(acumuladoMes) || 0) + (Number(total) || 0)
  );
  const saldoDisponibleMes = Math.max(0, toleradoNumber - consumoTotalMes);
  const excedenteMes = Math.max(0, consumoTotalMes - toleradoNumber);

  const btnComentario = {
    icono: mail,
    action: handleClickOpen,
  };

  const renderReadOnlyView = () => {
    const cabecera = resultado.datos.cabecera || resultado.datos;
    // Fecha y hora: asumiendo que fecha viene como string. Si hay campo hora, usarlo.
    const fechaDisplay = cabecera.fecha || "Fecha no disponible";
    
    return (
      <div style={{ padding: "16px" }}>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle style={{ textAlign: "center", fontSize: "1.2em" }}>
              {fechaDisplay}
            </IonCardTitle>
            <div style={{ textAlign: "center", marginTop: "8px", color: "#666" }}>
              ID: {cabecera.id}
            </div>
            {/* Update Ref to use codigo_referencia if available, else ps */}
            {(cabecera.codigo_referencia || ps) && (
              <div style={{ textAlign: "center", marginTop: "4px", fontWeight: "bold", color: "#333" }}>
                Ref: {cabecera.codigo_referencia || ps}
              </div>
            )}
          </IonCardHeader>
          <div style={{ padding: "0 16px 16px 16px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <strong>Estado:</strong>
              <span>{estadoMostrar}</span>
            </div>
            {/* Envío a Proactif en curso: el pedido ya fue aceptado y se está
                enviando en segundo plano. Se muestra al re-entrar al pedido. */}
            {String((cabecera as any)?.envio_estado || "") === "procesando" && (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <strong>Envío:</strong>
                <IonBadge color="primary" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                  <IonSpinner name="dots" style={{ width: 16, height: 16 }} />
                  Enviando a Proactif…
                </IonBadge>
              </div>
            )}
            {String((cabecera as any)?.envio_estado || "") === "parcial" && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <strong>Envío:</strong>
                <IonBadge color="warning">Envío parcial</IonBadge>
              </div>
            )}
            {String((cabecera as any)?.envio_estado || "") === "error" && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <strong>Envío:</strong>
                <IonBadge color="danger">Error de envío</IonBadge>
              </div>
            )}
            {Number((cabecera as any)?.comodato) === 1 && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <strong>Tipo:</strong>
                <span>Comodato</span>
              </div>
            )}
            {/* Add PV below Estado */}
            {cabecera.codigo_referencia && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <strong>PV:</strong>
                <span>{cabecera.codigo_referencia}</span>
              </div>
            )}
            {cabecera.ps_nombre && (
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                <strong>Punto de Servicio:</strong>
                <span style={{ textAlign: "right", maxWidth: "60%" }}>{cabecera.ps_nombre}</span>
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px", fontSize: "1.1em" }}>
              <strong>Total:</strong>
              <span>{formatPYG(total)} Gs.</span>
            </div>
          </div>
        </IonCard>

        {/* Sección de Comentarios - Solo visible si hay comentarios */}
        {comments && comments.length > 0 && (
          <IonCard>
            <IonCardHeader>
              <IonCardTitle style={{ fontSize: "1em" }}>Comentarios / Mensajes</IonCardTitle>
            </IonCardHeader>
            <div style={{ padding: "0 16px 16px 16px" }}>
              <IonList>
                {comments.map((c, i) => (
                  <IonItem key={i} lines="none" style={{ '--padding-start': '0' }}>
                    <IonLabel className="ion-text-wrap">
                      <h3>{c.usuario || "Usuario"}</h3>
                      <p>{c.comentario}</p>
                      <p style={{ fontSize: "0.8em", color: "#999" }}>{c.fecha}</p>
                    </IonLabel>
                  </IonItem>
                ))}
              </IonList>
            </div>
          </IonCard>
        )}

        {/* Tabla de Productos */}
        <IonCard>
          <IonCardHeader>
            <IonCardTitle style={{ fontSize: "1em" }}>Detalle de Productos</IonCardTitle>
          </IonCardHeader>
          {hayInconsistenciaEnvio && (
            <div style={{ padding: "0 12px 8px 12px" }}>
              <IonBadge color="warning" style={{ fontSize: "12px", whiteSpace: "normal", padding: "8px 10px" }}>
                Inconsistencia detectada: cabecera enviada, pero hay {productosNoEnviados} item(s) no enviados.
              </IonBadge>
            </div>
          )}
          <div style={{ padding: "0" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9em" }}>
              <thead style={{ backgroundColor: "#f4f4f4" }}>
                <tr>
                  <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #ddd" }}>Producto</th>
                  <th style={{ padding: "10px", textAlign: "center", borderBottom: "1px solid #ddd" }}>Cant.</th>
                  {mostrarTrazabilidadEnvio && (
                    <th style={{ padding: "10px", textAlign: "center", borderBottom: "1px solid #ddd" }}>Enviado</th>
                  )}
                  <th style={{ padding: "10px", textAlign: "right", borderBottom: "1px solid #ddd" }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {productos.map((p, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                    <td style={{ padding: "10px" }}>
                      <div style={{ fontWeight: "bold", color: "#333" }}>{p.prod_nombre || p.item_cod}</div>
                      <div style={{ fontSize: "1.08em", color: "#000", marginTop: "4px", lineHeight: "1.2" }}>{p.prod_descripcion || p.item_desc}</div>
                    </td>
                    <td style={{ padding: "10px", textAlign: "center" }}>{p.cantidad}</td>
                    {mostrarTrazabilidadEnvio && (
                      <td style={{ padding: "10px", textAlign: "center" }}>
                        <IonBadge color={Number((p as any).enviado || 0) === 1 ? "success" : "danger"}>
                          {Number((p as any).enviado || 0) === 1 ? "SI" : "NO"}
                        </IonBadge>
                      </td>
                    )}
                    <td style={{ padding: "10px", textAlign: "right" }}>
                      {formatPYG((p.precio_unitario || p.precio || 0) * (p.cantidad || 0))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </IonCard>
      </div>
    );
  };

  return (
    <IonPage>
      <Header
        titulo="Pedido de Productos"
        botonesDerecha={[btnComentario]}
        botonIzq={{
          url: readonly ? "/mis-pedidos" : "/pedido-de-productos",
          icono: arrowBackOutline,
        }}
      />
      <IonContent>
      {pedidoRechazado ? (
          <div style={{ textAlign: "center", paddingTop: "20px" }}>
            <div
              style={{
                fontSize: "180px",
                color: "#8C0032", // Rojo para simbolizar rechazo
                marginBottom: "20px",
                marginTop: "60px",
              }}
            >
              <IonIcon icon={closeCircle} />
            </div>
            <h2>
              El pedido con ID{" "}
              <strong>
                {resultado.datos.id || resultado.datos.cabecera.id}
              </strong>{" "}
              ha sido rechazado correctamente.
            </h2>
            <IonButton color="medium" routerLink="/pedido-de-productos">
              &laquo; volver atrás
            </IonButton>
          </div>
        ) : signal ? (
          renderConfirmation()
        ) : readonly ? (
          renderReadOnlyView()
        ) : (
          renderFacturado(facturado)
        )}

        {/* Alternativas para un producto sin stock */}
        <IonModal isOpen={productoSinStock !== null} onDidDismiss={cerrarAlternativas}>
          <IonContent className="ion-padding">
            <h2 style={{ marginTop: 0 }}>Alternativas con stock</h2>
            {productoSinStock && (
              <p style={{ margin: "4px 0 12px", color: "var(--ion-color-medium)" }}>
                <strong>{getProductCode(productoSinStock)}</strong>{" "}
                {productoSinStock.item_desc || productoSinStock.prod_descripcion}
                <br />
                {productos.some((p) => getProductKey(p) === getProductKey(productoSinStock))
                  ? `Sin stock disponible este mes · querías ${cantidadDeseada(productoSinStock)} u.`
                  : "Sin stock disponible este mes · la cantidad se ajusta después en la tarjeta"}
                {!bloqueaSinStock && (
                  <>
                    <br />
                    Podés usar una alternativa o pedirlo igual.
                  </>
                )}
              </p>
            )}

            {cargandoAlternativas && (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <IonSpinner />
              </div>
            )}

            {!cargandoAlternativas && alternativas && alternativas.alternativas.length === 0 && (
              <IonText color="medium">
                <p>{alternativas.motivo || "No hay alternativas con stock disponible"}</p>
              </IonText>
            )}

            {!cargandoAlternativas &&
              alternativas?.alternativas.map((alternativa, index) => (
                <IonCard key={alternativa.codigo} style={{ margin: "0 0 10px", padding: "10px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: "8px" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "bold" }}>
                        {alternativa.codigo}
                        {index === 0 && !alternativa.confirmada && (
                          <IonBadge color="success" style={{ marginLeft: "6px" }}>Recomendada</IonBadge>
                        )}
                        {alternativa.confirmada && (
                          <IonBadge color="tertiary" style={{ marginLeft: "6px" }}>Ya elegida en este PS</IonBadge>
                        )}
                      </div>
                      <div style={{ color: "var(--ion-color-medium-shade)", fontSize: "13px" }}>{alternativa.descripcion}</div>
                      <div style={{ fontSize: "13px", marginTop: "4px" }}>
                        Disponible: {alternativa.disponible} · Precio: {formatPYG(alternativa.precio_unitario)}
                      </div>
                      {alternativa.diferencias.length > 0 && (
                        <div style={{ fontSize: "12px", color: "var(--ion-color-warning-shade)", marginTop: "2px" }}>
                          {alternativa.diferencias.join(" · ")}
                        </div>
                      )}
                    </div>
                    <div style={{ alignSelf: "center" }}>
                      <IonButton size="small" onClick={() => usarAlternativa(alternativa)}>
                        Usar ({Math.min(Math.max(1, alternativa.cantidad_sugerida), alternativa.disponible)} u.)
                      </IonButton>
                    </div>
                  </div>
                </IonCard>
              ))}

            <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>
              {!cargandoAlternativas && (alternativas?.alternativas.length ?? 0) > 0 && (
                <IonButton style={{ flex: 1 }} fill="outline" color="medium" onClick={rechazarAlternativas}>
                  {bloqueaSinStock ? "Ninguna sirve" : "Pedir el original"}
                </IonButton>
              )}
              <IonButton style={{ flex: 1 }} fill="clear" color="medium" onClick={cerrarAlternativas}>
                Cerrar
              </IonButton>
            </div>
          </IonContent>
        </IonModal>

        {/* Vista previa: el pedido se envía recién cuando se confirma acá */}
        <IonModal
          isOpen={vistaPreviaAbierta}
          onDidDismiss={() => setVistaPreviaAbierta(false)}
        >
          <IonContent className="ion-padding">
            <h2 style={{ marginTop: 0 }}>Vista previa del pedido</h2>
            <p style={{ margin: "4px 0", color: "var(--ion-color-medium)" }}>
              Punto de servicio: <strong>{ps}</strong>
            </p>
            {stockSincronizado && (
              <p style={{ margin: "4px 0", color: "var(--ion-color-medium)", fontSize: "13px" }}>
                Stock al {moment(stockSincronizado).format("DD/MM HH:mm")}
                {bloqueaSinStock ? ": se vuelve a controlar al confirmar" : ""}
              </p>
            )}
            <IonBadge color={esComodato || porcentaje > 0 ? "warning" : "success"}>
              {destinoPedido}
            </IonBadge>

            <div
              style={{
                marginTop: "12px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "8px",
                fontSize: "14px",
              }}
            >
              <div>
                Ítems: <strong>{itemsVistaPrevia.length}</strong>
              </div>
              <div>
                Total: <strong>{formatPYG(totalVistaPrevia)}</strong>
              </div>
              {!esComodato && (
                <>
                  <div>
                    Tolerado: <strong>{formatPYG(tolerado)}</strong>
                  </div>
                  <div>
                    {frecuenciaMeses > 1 ? `Consumido de los últimos ${frecuenciaMeses} meses` : 'Consumido del mes'}: <strong>{formatPYG(acumuladoMes)}</strong>
                  </div>
                  <div>
                    Restante si confirmás: <strong>{formatPYG(restanteConEste)}</strong>
                  </div>
                </>
              )}
            </div>

            <div style={{ overflowX: "auto", marginTop: "12px" }}>
              <table
                style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}
              >
                <thead>
                  <tr style={{ background: "#f2f2f2" }}>
                    <th style={{ padding: "8px", textAlign: "left" }}>Producto</th>
                    <th style={{ padding: "8px", textAlign: "center" }}>Cant.</th>
                    <th style={{ padding: "8px", textAlign: "right" }}>P. unit.</th>
                    <th style={{ padding: "8px", textAlign: "right" }}>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  {itemsVistaPrevia.map((producto) => (
                    <tr
                      key={getProductKey(producto)}
                      style={{ borderBottom: "1px solid #eee" }}
                    >
                      <td style={{ padding: "8px" }}>
                        <div style={{ fontWeight: "bold" }}>
                          {producto.item_cod || producto.prod_nombre}
                        </div>
                        <div style={{ color: "#666" }}>
                          {producto.item_desc || producto.prod_descripcion}
                        </div>
                      </td>
                      <td style={{ padding: "8px", textAlign: "center" }}>
                        {producto.cantidad}
                      </td>
                      <td style={{ padding: "8px", textAlign: "right" }}>
                        {formatPYG(producto.precio_unitario || producto.precio || 0)}
                      </td>
                      <td style={{ padding: "8px", textAlign: "right" }}>
                        {formatPYG(
                          producto.cantidad *
                            (producto.precio_unitario || producto.precio || 0)
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
              <IonButton
                style={{ flex: 1 }}
                fill="outline"
                color="medium"
                onClick={() => setVistaPreviaAbierta(false)}
              >
                Volver a editar
              </IonButton>
              <IonButton style={{ flex: 1 }} disabled={enviando} onClick={realizarPedido}>
                {esComodato || porcentaje > 0 ? "Confirmar y solicitar" : "Confirmar y enviar"}
              </IonButton>
            </div>
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(PedidoDeProductos);
